import { gql } from "apollo-angular";
import * as Apollo from "apollo-angular";

import { Injectable } from "@angular/core";

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** An arbitrary precision integer */
  Asn: { input: any; output: any };
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any };
  IPv4Address: { input: any; output: any };
  IPv4Network: { input: any; output: any };
  IPv6Address: { input: any; output: any };
  IPv6Network: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any };
  UUID: { input: string; output: string };
};

/** Information about wireless access point */
export type AccessPointType = {
  __typename?: "AccessPointType";
  brand?: Maybe<Scalars["String"]["output"]>;
  ciStatus?: Maybe<Scalars["String"]["output"]>;
  firmwareVersion?: Maybe<Scalars["String"]["output"]>;
  key?: Maybe<Scalars["String"]["output"]>;
  model?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  serialNumber?: Maybe<Scalars["String"]["output"]>;
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  supplier?: Maybe<Scalars["String"]["output"]>;
};

/** Information about address */
export type AddressType = {
  __typename?: "AddressType";
  addition?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  countryCode?: Maybe<Scalars["String"]["output"]>;
  extraAddressLine?: Maybe<Scalars["String"]["output"]>;
  number?: Maybe<Scalars["String"]["output"]>;
  street?: Maybe<Scalars["String"]["output"]>;
  zipcode?: Maybe<Scalars["String"]["output"]>;
};

/** Affected subscription */
export type AffectedSubscriptionType = {
  __typename?: "AffectedSubscriptionType";
  impactType: Scalars["String"]["output"];
  subscription: ImpactedSubscriptionType;
  subscriptionId: Scalars["String"]["output"];
};

/** Information about aggregate parent of a service port */
export type AggregateParentType = {
  __typename?: "AggregateParentType";
  customerDescription: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  product: ProductType;
  subscriptionId: Scalars["UUID"]["output"];
};

/** Information about aggsp */
export type AggspSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "AggspSubscriptionDetailsType";
  address?: Maybe<AddressType>;
  amountReserved: Scalars["Int"]["output"];
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  linkMemberSubscriptions: Array<LinkMemberDetailsType>;
  locationDescription?: Maybe<Scalars["String"]["output"]>;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  portId?: Maybe<Scalars["Int"]["output"]>;
  portMode?: Maybe<Scalars["String"]["output"]>;
  portSpeed?: Maybe<Scalars["Int"]["output"]>;
  portSubscription?: Maybe<Scalars["UUID"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  services?: Maybe<Array<ServiceType>>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  subscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
  surfLocationCode?: Maybe<Scalars["String"]["output"]>;
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

/** Information about AIRT Scan records */
export type AirtScan = {
  __typename?: "AirtScan";
  /** Contents of Intel MQ Classification field */
  classification?: Maybe<Scalars["JSON"]["output"]>;
  /** CRM Organisation UUID */
  customerId?: Maybe<Scalars["String"]["output"]>;
  /** Contents of Intel MQ Destination field */
  destination?: Maybe<Scalars["JSON"]["output"]>;
  /** Contents of Intel MQ Extra field */
  extra?: Maybe<Scalars["JSON"]["output"]>;
  /** Contents of Intel MQ Feed field */
  feed?: Maybe<Scalars["JSON"]["output"]>;
  /** First time seen this message */
  firstSeen?: Maybe<Scalars["String"]["output"]>;
  /** Unique AIRT Scan record identifier */
  id: Scalars["String"]["output"];
  /** Datetime of import */
  importedAt: Scalars["String"]["output"];
  /** Last time seen this message */
  lastSeen?: Maybe<Scalars["String"]["output"]>;
  /** Contents of Intel MQ Malware field */
  malware?: Maybe<Scalars["JSON"]["output"]>;
  /** Mongo collection version */
  modelVersion: Scalars["String"]["output"];
  /** The amount of hits on this IP in the queried time period */
  numberOfHits?: Maybe<Scalars["Int"]["output"]>;
  /** Contents of Intel MQ Protocol field */
  protocol?: Maybe<Scalars["JSON"]["output"]>;
  /** Contents of the Severity field */
  severity?: Maybe<Scalars["String"]["output"]>;
  /** Contents of Intel MQ Source field */
  source?: Maybe<Scalars["JSON"]["output"]>;
  /** Contents of Intel MQ Time field */
  time?: Maybe<Scalars["JSON"]["output"]>;
};

export type AirtScanConnection = {
  __typename?: "AirtScanConnection";
  edges: Array<AirtScanEdge>;
  pageInfo: PageInfo;
};

export type AirtScanEdge = {
  __typename?: "AirtScanEdge";
  cursor: Scalars["Int"]["output"];
  node: AirtScan;
};

export type AirtSort = {
  order: Array<AirtSortField>;
};

/** Sort ordering of results */
export type AirtSortField = {
  firstObservation?: InputMaybe<SortOrder>;
  ip?: InputMaybe<SortOrder>;
  lastObservation?: InputMaybe<SortOrder>;
  scan?: InputMaybe<SortOrder>;
  severity?: InputMaybe<SortOrder>;
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type BaseSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Base sort ordering of results */
export type BaseSubscriptionSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

export enum Category {
  General = "GENERAL",
  Malfunction = "MALFUNCTION",
  Plannedwork = "PLANNEDWORK",
}

/** Information about a circuit */
export type CircuitType = {
  __typename?: "CircuitType";
  endpoints: Array<ServiceAttachPointType>;
  name: Scalars["String"]["output"];
  serviceId?: Maybe<Scalars["String"]["output"]>;
  serviceSpeed?: Maybe<Scalars["Int"]["output"]>;
  subscriptionInstanceId: Scalars["UUID"]["output"];
  tag: Scalars["String"]["output"];
};

export type Counts = {
  __typename?: "Counts";
  /** Firewall subscriptions count */
  fw: SubscriptionCount;
  /** IP subscriptions count */
  ip: SubscriptionCount;
  /** IP Prefix subscriptions count */
  ipPrefix: SubscriptionCount;
  /** L2VPN subscriptions count */
  l2vpn: SubscriptionCountWithFirewallsEnabled;
  /** L3VPN subscriptions count */
  l3vpn: SubscriptionCountWithFirewallsEnabled;
  /** LightPath subscriptions count */
  lp: SubscriptionCount;
  /** Port subscriptions count */
  port: SubscriptionCount;
  /** SURFwired subscriptions count */
  wired: SubscriptionCount;
  /** SURFwireless subscriptions count */
  wireless: SubscriptionCount;
};

export type CountsFwArgs = {
  customerId: Scalars["UUID"]["input"];
};

export type CountsIpArgs = {
  customerId: Scalars["UUID"]["input"];
};

export type CountsIpPrefixArgs = {
  customerId: Scalars["UUID"]["input"];
};

export type CountsL2vpnArgs = {
  customerId: Scalars["UUID"]["input"];
};

export type CountsL3vpnArgs = {
  customerId: Scalars["UUID"]["input"];
};

export type CountsLpArgs = {
  customerId: Scalars["UUID"]["input"];
};

export type CountsPortArgs = {
  customerId: Scalars["UUID"]["input"];
};

export type CountsWiredArgs = {
  customerId: Scalars["UUID"]["input"];
};

export type CountsWirelessArgs = {
  customerId: Scalars["UUID"]["input"];
};

/** Information about customer */
export type CustomerType = {
  __typename?: "CustomerType";
  customerId: Scalars["UUID"]["output"];
  fullname: Scalars["String"]["output"];
};

/** DNS Firewall Type */
export type DnsFirewallType = {
  __typename?: "DNSFirewallType";
  action: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  hit: Scalars["String"]["output"];
  ipAddress: Scalars["String"]["output"];
  recordedAt?: Maybe<Scalars["DateTime"]["output"]>;
  resolver: Scalars["String"]["output"];
  rpzFeed: Scalars["String"]["output"];
};

export type DnsFirewallTypeConnection = {
  __typename?: "DNSFirewallTypeConnection";
  edges: Array<DnsFirewallTypeEdge>;
  pageInfo: PageInfo;
};

export type DnsFirewallTypeEdge = {
  __typename?: "DNSFirewallTypeEdge";
  cursor: Scalars["Int"]["output"];
  node: DnsFirewallType;
};

/** Filter DNS Firewall by attribute, all ranges are inclusive */
export type DnsFirewallSearchFilter = {
  /** Case insensitive on Action */
  action?: InputMaybe<Scalars["String"]["input"]>;
  /** Return results after import date */
  afterRecordedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Return results before import date */
  beforeRecordedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Case insensitive on Hit */
  hit?: InputMaybe<Scalars["String"]["input"]>;
  /** Case insensitive search on ip address */
  ipAddress?: InputMaybe<Scalars["String"]["input"]>;
  /** Search on IP prefixes */
  ipPrefixes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Case insensitive on Resolver */
  resolver?: InputMaybe<Scalars["String"]["input"]>;
  /** Case insensitive on RPZ Feed */
  rpzFeed?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type DnsFirewallSort = {
  order: Array<DnsFirewallSortField>;
};

/** Sort ordering of results */
export type DnsFirewallSortField = {
  action?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  hit?: InputMaybe<SortOrder>;
  ipAddress?: InputMaybe<SortOrder>;
  recordedAt?: InputMaybe<SortOrder>;
  resolver?: InputMaybe<SortOrder>;
  rpzFeed?: InputMaybe<SortOrder>;
};

/** Information about ESI */
export type EthernetSegmentIdentifierType = {
  __typename?: "EthernetSegmentIdentifierType";
  endpoints?: Maybe<Array<ServiceAttachPointType>>;
  firewallInterconnect?: Maybe<L2InterconnectType>;
  segmentId?: Maybe<Scalars["Int"]["output"]>;
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type EvpnPtpSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type EvpnPtpSubscriptionSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

/** Information about firewall */
export type FirewallSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "FirewallSubscriptionDetailsType";
  availabilityZone?: Maybe<Scalars["String"]["output"]>;
  customer?: Maybe<CustomerType>;
  customerAsn?: Maybe<Scalars["Asn"]["output"]>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  firewallEnabled: Scalars["Boolean"]["output"];
  fwAsn: Scalars["Asn"]["output"];
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  ipGateway?: Maybe<IpGatewayType>;
  l2Endpoints: Array<L2EndpointType>;
  l3Endpoints: Array<L3EndpointType>;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  protection: Scalars["String"]["output"];
  references: Array<ReferenceType>;
  serviceSpeed: Scalars["Int"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  topology: Array<Array<TopologyObjectType>>;
  version: Scalars["Int"]["output"];
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type FirewallSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type FirewallSubscriptionSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

/** Information about SURFfirewall */
export type FirewallSubscriptionType = SubscriptionDetails & {
  __typename?: "FirewallSubscriptionType";
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  protection: Scalars["String"]["output"];
  references: Array<ReferenceType>;
  serviceSpeed: Scalars["Int"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type FirewallSubscriptionTypeConnectionV2 = {
  __typename?: "FirewallSubscriptionTypeConnectionV2";
  page: Array<FirewallSubscriptionType>;
  pageInfo: PageInfo;
};

/** Information about ip service attach point */
export type IpServiceAttachPointType = {
  __typename?: "IPServiceAttachPointType";
  address?: Maybe<AddressType>;
  bfd?: Maybe<Scalars["Boolean"]["output"]>;
  bfdMinimumInterval?: Maybe<Scalars["Int"]["output"]>;
  bfdMultiplier?: Maybe<Scalars["Int"]["output"]>;
  bgpExportPolicy?: Maybe<Scalars["String"]["output"]>;
  bgpHashAlgorithm?: Maybe<Scalars["String"]["output"]>;
  bgpPassword?: Maybe<Scalars["String"]["output"]>;
  bgpSessionPriority?: Maybe<Scalars["String"]["output"]>;
  gracefulRestart?: Maybe<Scalars["Boolean"]["output"]>;
  ipPrefixes: Array<Scalars["String"]["output"]>;
  ipv4Mtu?: Maybe<Scalars["Int"]["output"]>;
  ipv4PointToPointPrefix?: Maybe<IpPointToPointPrefixType>;
  ipv6Mtu?: Maybe<Scalars["Int"]["output"]>;
  ipv6PointToPointPrefix?: Maybe<IpPointToPointPrefixType>;
  name: Scalars["String"]["output"];
  organisation?: Maybe<Scalars["String"]["output"]>;
  ownerSubscriptionId: Scalars["UUID"]["output"];
  port?: Maybe<ServicePortSubscriptionType>;
  portSubscriptionId: Scalars["UUID"]["output"];
  subscriptionInstanceId: Scalars["UUID"]["output"];
  tag: Scalars["String"]["output"];
  vlanrange: Scalars["String"]["output"];
};

export type IpSubscriptionListItemType = {
  __typename?: "IPSubscriptionListItemType";
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  product: ProductType;
  subscriptionId: Scalars["UUID"]["output"];
};

export enum Impact {
  Down = "DOWN",
  NoImpact = "NO_IMPACT",
  ReducedRedundancy = "REDUCED_REDUNDANCY",
  ResilienceLoss = "RESILIENCE_LOSS",
  Unknown = "UNKNOWN",
}

/** Impacted subscription */
export type ImpactedSubscriptionType = {
  __typename?: "ImpactedSubscriptionType";
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  product?: Maybe<ProductType>;
  subscriptionId: Scalars["UUID"]["output"];
};

/** Information about ip gateway */
export type IpGatewayType = {
  __typename?: "IpGatewayType";
  ipPrefixes: Array<Scalars["String"]["output"]>;
  ipv4Mtu?: Maybe<Scalars["Int"]["output"]>;
  ipv6Mtu?: Maybe<Scalars["Int"]["output"]>;
  multiCast: Scalars["Boolean"]["output"];
  sapSubscriptionInstanceIds: Array<Scalars["UUID"]["output"]>;
  serviceSpeed: Scalars["Int"]["output"];
  subscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
  surfcertFilter: Scalars["String"]["output"];
  upLinkLocations: Array<UplinkLocationType>;
};

/** Information about ip ptp prefix */
export type IpPointToPointPrefixType = {
  __typename?: "IpPointToPointPrefixType";
  clientFQDN: Scalars["String"]["output"];
  clientIpAddress: Scalars["String"]["output"];
  network: Scalars["String"]["output"];
  surfFQDN: Scalars["String"]["output"];
  surfIpAddress: Scalars["String"]["output"];
};

/** Information about ip_prefix ddos */
export type IpPrefixDdosType = {
  __typename?: "IpPrefixDdosType";
  afi: Scalars["Int"]["output"];
  autoMitigation?: Maybe<Scalars["Boolean"]["output"]>;
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty?: Maybe<Scalars["Boolean"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  prefix: Scalars["String"]["output"];
  prefixType?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  version: Scalars["Int"]["output"];
};

export type IpPrefixDdosTypeConnectionV2 = {
  __typename?: "IpPrefixDdosTypeConnectionV2";
  page: Array<IpPrefixDdosType>;
  pageInfo: PageInfo;
};

/** Filter list by attribute, all ranges are inclusive */
export type IpPrefixSubscriptionDdosFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type IpPrefixSubscriptionDdosSort = {
  customerId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  ipPrefix?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
  version?: InputMaybe<SortOrder>;
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type IpPrefixSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type IpPrefixSubscriptionSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

/** Information about ipprefix */
export type IpPrefixSubscriptionType = SubscriptionDetails & {
  __typename?: "IpPrefixSubscriptionType";
  autoMitigation: Scalars["String"]["output"];
  availableIpSubscriptions: Array<IpSubscriptionListItemType>;
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  ipPrefix?: Maybe<IpPrefixType>;
  ipSubscriptions: Array<IpSubscriptionListItemType>;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type IpPrefixSubscriptionTypeConnectionV2 = {
  __typename?: "IpPrefixSubscriptionTypeConnectionV2";
  page: Array<IpPrefixSubscriptionType>;
  pageInfo: PageInfo;
};

/** Information about ipprefix */
export type IpPrefixType = {
  __typename?: "IpPrefixType";
  afi: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  ipamPrefixId: Scalars["Int"]["output"];
  ipamPrefixTags?: Maybe<Array<Scalars["String"]["output"]>>;
  name?: Maybe<Scalars["String"]["output"]>;
  parentLabel?: Maybe<Scalars["String"]["output"]>;
  prefix: Scalars["String"]["output"];
  state: Scalars["Int"]["output"];
  stateLabel?: Maybe<Scalars["String"]["output"]>;
  subscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
  tag?: Maybe<Scalars["String"]["output"]>;
  vrf: Scalars["Int"]["output"];
  vrfLabel?: Maybe<Scalars["String"]["output"]>;
};

/** Information about ip service settings */
export type IpServiceSettingsType = {
  __typename?: "IpServiceSettingsType";
  asn?: Maybe<Scalars["Int"]["output"]>;
  multicast?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  subscriptionInstanceId: Scalars["UUID"]["output"];
  surfcertFilter: Scalars["String"]["output"];
  tag: Scalars["String"]["output"];
};

/** Information about ip */
export type IpSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "IpSubscriptionDetailsType";
  availabilityZone?: Maybe<Scalars["String"]["output"]>;
  circuits: Array<CircuitType>;
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  firewallEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  ipRoutingType: Scalars["String"]["output"];
  ipss: IpServiceSettingsType;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  protection: Scalars["String"]["output"];
  references: Array<ReferenceType>;
  saps: Array<IpServiceAttachPointType>;
  serviceId?: Maybe<Scalars["String"]["output"]>;
  serviceSpeed: Scalars["Int"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  topology: Array<Array<TopologyObjectType>>;
  version: Scalars["Int"]["output"];
};

/** Information about IP */
export type IpSubscriptionListType = SubscriptionDetails & {
  __typename?: "IpSubscriptionListType";
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  ipRoutingType: Scalars["String"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  protection: Scalars["String"]["output"];
  references: Array<ReferenceType>;
  serviceSpeed: Scalars["Int"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type IpSubscriptionListTypeConnectionV2 = {
  __typename?: "IpSubscriptionListTypeConnectionV2";
  page: Array<IpSubscriptionListType>;
  pageInfo: PageInfo;
};

/** Information about irb */
export type IrbSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "IrbSubscriptionDetailsType";
  address?: Maybe<AddressType>;
  amountReserved: Scalars["Int"]["output"];
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  locationDescription?: Maybe<Scalars["String"]["output"]>;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  portId?: Maybe<Scalars["Int"]["output"]>;
  portMode?: Maybe<Scalars["String"]["output"]>;
  portSpeed?: Maybe<Scalars["Int"]["output"]>;
  portSubscription?: Maybe<Scalars["UUID"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  services: Array<ServiceType>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  subscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
  surfLocationCode?: Maybe<Scalars["String"]["output"]>;
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

/** Information about L2 endpoint */
export type L2EndpointType = {
  __typename?: "L2EndpointType";
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  ipv4PtpPrefixes: Array<Scalars["Int"]["output"]>;
  ipv6PtpPrefixes: Array<Scalars["Int"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  otherSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  product: ProductType;
  sapSubscriptionInstanceIds: Array<Scalars["UUID"]["output"]>;
  serviceSpeed: Scalars["Int"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  subscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
};

/** Information about L2 Interconnect */
export type L2InterconnectType = {
  __typename?: "L2InterconnectType";
  availabilityZone?: Maybe<Scalars["String"]["output"]>;
  customerId?: Maybe<Scalars["UUID"]["output"]>;
  description: Scalars["String"]["output"];
  endpoints?: Maybe<Array<ServiceAttachPointType>>;
  firewallSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  saps: Array<ServiceAttachPointType>;
  subscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
};

/** Information about L2VPN circuit */
export type L2VpnCircuitType = {
  __typename?: "L2VPNCircuitType";
  bumFilter?: Maybe<Scalars["Boolean"]["output"]>;
  endpoints: Array<ServiceAttachPointType>;
  esis: Array<EthernetSegmentIdentifierType>;
  name: Scalars["String"]["output"];
  serviceId?: Maybe<Scalars["String"]["output"]>;
  serviceSpeed?: Maybe<Scalars["Int"]["output"]>;
  speedPolicer?: Maybe<Scalars["Boolean"]["output"]>;
  subscriptionInstanceId: Scalars["UUID"]["output"];
  tag: Scalars["String"]["output"];
  vlanRetagging?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Information about L2VPN */
export type L2VpnSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "L2VPNSubscriptionDetailsType";
  circuits: Array<L2VpnCircuitType>;
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  esis: Array<EthernetSegmentIdentifierType>;
  firewallEnabled: Scalars["Boolean"]["output"];
  firewallInterconnects: Array<L2InterconnectType>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  protection: Scalars["String"]["output"];
  references: Array<ReferenceType>;
  saps: Array<ServiceAttachPointType>;
  serviceId?: Maybe<Scalars["String"]["output"]>;
  serviceSpeed: Scalars["Int"]["output"];
  speedPolicer: Scalars["Boolean"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  topology: Array<Array<TopologyObjectType>>;
  version: Scalars["Int"]["output"];
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type L2VpnSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type L2VpnSubscriptionSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

/** Information about l2vpn */
export type L2VpnSubscriptionType = {
  __typename?: "L2VpnSubscriptionType";
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  firewallEnabled: Scalars["Boolean"]["output"];
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  serviceSpeed: Scalars["Int"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type L2VpnSubscriptionTypeConnectionV2 = {
  __typename?: "L2VpnSubscriptionTypeConnectionV2";
  page: Array<L2VpnSubscriptionType>;
  pageInfo: PageInfo;
};

/** Information about L3 endpoint */
export type L3EndpointType = {
  __typename?: "L3EndpointType";
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  organisation?: Maybe<Scalars["String"]["output"]>;
  otherSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  product: ProductType;
  sapSubscriptionInstanceIds: Array<Scalars["UUID"]["output"]>;
  serviceSpeed: Scalars["Int"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  subscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
};

/** Information about L3VPN firewall interconnect */
export type L3FwInterconnectType = {
  __typename?: "L3FwInterconnectType";
  availabilityZone: Scalars["String"]["output"];
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  firewallAsn: Scalars["String"]["output"];
  firewallSubscriptionId: Scalars["UUID"]["output"];
  ipv4AddressFirewall?: Maybe<Scalars["IPv4Address"]["output"]>;
  ipv4MaxPrefix?: Maybe<Scalars["Int"]["output"]>;
  ipv4Mtu?: Maybe<Scalars["Int"]["output"]>;
  ipv4Prefix?: Maybe<Scalars["IPv4Network"]["output"]>;
  ipv6AddressFirewall?: Maybe<Scalars["IPv6Address"]["output"]>;
  ipv6MaxPrefix?: Maybe<Scalars["Int"]["output"]>;
  ipv6Mtu?: Maybe<Scalars["Int"]["output"]>;
  ipv6Prefix?: Maybe<Scalars["IPv6Network"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  saps: Array<ServiceAttachPointType>;
  subscriptionId: Scalars["UUID"]["output"];
  subscriptionInstanceId: Scalars["UUID"]["output"];
};

/** Information about L3VPN circuit */
export type L3VpnCircuitType = {
  __typename?: "L3VPNCircuitType";
  endpoints: Array<ServiceAttachPointType>;
  name: Scalars["String"]["output"];
  serviceId?: Maybe<Scalars["String"]["output"]>;
  serviceSpeed?: Maybe<Scalars["Int"]["output"]>;
  speedPolicer?: Maybe<Scalars["Boolean"]["output"]>;
  subscriptionInstanceId: Scalars["UUID"]["output"];
  tag: Scalars["String"]["output"];
};

/** Information about L3VPN service settings */
export type L3VpnsapServiceSettingsType = {
  __typename?: "L3VPNSAPServiceSettingsType";
  asn: Scalars["Int"]["output"];
  bfd?: Maybe<Scalars["Boolean"]["output"]>;
  bfdMinimumInterval?: Maybe<Scalars["Int"]["output"]>;
  bfdMultiplier?: Maybe<Scalars["Int"]["output"]>;
  bgpMetric?: Maybe<Scalars["String"]["output"]>;
  bgpPassword?: Maybe<Scalars["String"]["output"]>;
  ipv4Address?: Maybe<Scalars["String"]["output"]>;
  ipv4MaxPrefix?: Maybe<Scalars["Int"]["output"]>;
  ipv4Mtu?: Maybe<Scalars["Int"]["output"]>;
  ipv4RemoteAddress?: Maybe<Scalars["String"]["output"]>;
  ipv6Address?: Maybe<Scalars["String"]["output"]>;
  ipv6MaxPrefix?: Maybe<Scalars["Int"]["output"]>;
  ipv6Mtu?: Maybe<Scalars["Int"]["output"]>;
  ipv6RemoteAddress?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  sap: ServiceAttachPointType;
  subscriptionInstanceId: Scalars["UUID"]["output"];
  tag: Scalars["String"]["output"];
};

/** Information about L3VPN service settings */
export type L3VpnServiceSettingsType = {
  __typename?: "L3VPNServiceSettingsType";
  l3vpnAsn: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  subscriptionInstanceId: Scalars["UUID"]["output"];
  tag: Scalars["String"]["output"];
};

/** Information about L3VPN */
export type L3VpnSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "L3VPNSubscriptionDetailsType";
  circuits: Array<L3VpnCircuitType>;
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  firewallEnabled: Scalars["Boolean"]["output"];
  firewallInterconnects: Array<L3FwInterconnectType>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  l3vpnsapss: Array<L3VpnsapServiceSettingsType>;
  l3vpnss: L3VpnServiceSettingsType;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  protection: Scalars["String"]["output"];
  references: Array<ReferenceType>;
  serviceSpeed: Scalars["Int"]["output"];
  speedPolicer: Scalars["Boolean"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  topology: Array<Array<TopologyObjectType>>;
  version: Scalars["Int"]["output"];
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type L3VpnSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type L3VpnSubscriptionSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

/** Information about l3vpn */
export type L3VpnSubscriptionType = {
  __typename?: "L3VpnSubscriptionType";
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  firewallEnabled: Scalars["Boolean"]["output"];
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  serviceSpeed: Scalars["Int"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type L3VpnSubscriptionTypeConnectionV2 = {
  __typename?: "L3VpnSubscriptionTypeConnectionV2";
  page: Array<L3VpnSubscriptionType>;
  pageInfo: PageInfo;
};

export enum Language {
  Eng = "ENG",
  Nl = "NL",
}

/** Information about light path circuit */
export type LightPathCircuitType = {
  __typename?: "LightPathCircuitType";
  endpoints: Array<ServiceAttachPointType>;
  name: Scalars["String"]["output"];
  remotePortShutdown?: Maybe<Scalars["Boolean"]["output"]>;
  serviceId?: Maybe<Scalars["String"]["output"]>;
  serviceSpeed?: Maybe<Scalars["Int"]["output"]>;
  speedPolicer?: Maybe<Scalars["Boolean"]["output"]>;
  subscriptionInstanceId: Scalars["UUID"]["output"];
  tag: Scalars["String"]["output"];
};

/** Information about light path */
export type LightPathSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "LightPathSubscriptionDetailsType";
  circuits: Array<LightPathCircuitType>;
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  protection: Scalars["String"]["output"];
  references: Array<ReferenceType>;
  remotePortShutdown: Scalars["Boolean"]["output"];
  saps: Array<ServiceAttachPointType>;
  serviceId?: Maybe<Scalars["String"]["output"]>;
  serviceSpeed: Scalars["Int"]["output"];
  speedPolicer: Scalars["Boolean"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  topology: Array<Array<TopologyObjectType>>;
  version: Scalars["Int"]["output"];
};

/** Information about lightpath */
export type LightPathSubscriptionType = SubscriptionDetails & {
  __typename?: "LightPathSubscriptionType";
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  protection: Scalars["String"]["output"];
  references: Array<ReferenceType>;
  serviceSpeed: Scalars["Int"]["output"];
  services: Array<PortServiceType>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type LightPathSubscriptionTypeConnectionV2 = {
  __typename?: "LightPathSubscriptionTypeConnectionV2";
  page: Array<LightPathSubscriptionType>;
  pageInfo: PageInfo;
};

export type LinkMemberDetailsType = {
  __typename?: "LinkMemberDetailsType";
  amountReserved: Scalars["Int"]["output"];
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  ieeeInterfaceType?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  patchPosition?: Maybe<Scalars["String"]["output"]>;
  portSpeed: Scalars["Int"]["output"];
  product: ProductType;
  services: Array<ServiceType>;
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  vlanrange?: Maybe<Scalars["String"]["output"]>;
};

/** Information about a location (e.g. address, description, code) */
export type LocationType = {
  __typename?: "LocationType";
  address?: Maybe<AddressType>;
  locationDescription?: Maybe<Scalars["String"]["output"]>;
  surfLocationCode?: Maybe<Scalars["String"]["output"]>;
};

/** Filter major disruption notifications */
export type MajorDisruptionNotificationFilter = {
  /** Show notifications on and after this start date */
  beginTimestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter by subscription owner. This will filter notifications having at least 1 matching impacted object (subscription). The impacted objects per notification are also filtered. */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Show notifications on and before this end date, or without end date */
  endTimestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter by notification statuses */
  statuses?: Array<ProcessState>;
};

export type MscPortSubscriptionType = {
  __typename?: "MscPortSubscriptionType";
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
};

/** Information about msc */
export type MscSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "MscSubscriptionDetailsType";
  address?: Maybe<AddressType>;
  amountReserved: Scalars["Int"]["output"];
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  locationDescription?: Maybe<Scalars["String"]["output"]>;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  portId?: Maybe<Scalars["Int"]["output"]>;
  portMode?: Maybe<Scalars["String"]["output"]>;
  portSpeed?: Maybe<Scalars["Int"]["output"]>;
  portSubscription?: Maybe<MscPortSubscriptionType>;
  product: ProductType;
  references: Array<ReferenceType>;
  serviceTag?: Maybe<Scalars["Int"]["output"]>;
  services: Array<ServiceType>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  subscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
  surfLocationCode?: Maybe<Scalars["String"]["output"]>;
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

/** Filter for regular notifications */
export type NotificationFilter = {
  /** Use this customer for custom fields like 'customer_description' */
  accessCustomerId: Scalars["UUID"]["input"];
  /** Show notifications on and after this start date */
  beginTimestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter by subscription owner. This will filter notifications having at least 1 matching impacted object (subscription). The impacted objects per notification are also filtered. */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Show notifications on and before this end date, or without end date */
  endTimestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter by subscription impacts. This will filter notifications having at least 1 matching impacted object (subscription). The impacted objects per notification are also filtered. */
  impacts?: InputMaybe<Array<Impact>>;
  /** Filter by subscription product types. This will filter notifications having at least 1 matching impacted object (subscription). The impacted objects per notification are also filtered. */
  productTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Filter by notification statuses */
  statuses?: Array<ProcessState>;
  /** Filter by subscription ids. This will filter notifications having at least 1 matching impacted object (subscription). The impacted objects per notification are also filtered. */
  subscriptionIds?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
};

/** CIM notification */
export type NotificationType = {
  __typename?: "NotificationType";
  affectedSubscriptions: Array<AffectedSubscriptionType>;
  category: Category;
  createDate: Scalars["DateTime"]["output"];
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  heading: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  impact: Scalars["String"]["output"];
  notificationId: Scalars["String"]["output"];
  planDate?: Maybe<Scalars["DateTime"]["output"]>;
  processState: ProcessState;
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  status: Scalars["String"]["output"];
  summary: Scalars["String"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  type: TicketType;
  updates: Array<NotificationUpdate>;
  urgency: Urgency;
};

export type NotificationUpdate = {
  __typename?: "NotificationUpdate";
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  language: Language;
  timestamp: Scalars["DateTime"]["output"];
};

/** Pagination context to navigate objects with cursor-based pagination */
export type PageInfo = {
  __typename?: "PageInfo";
  endCursor?: Maybe<Scalars["Int"]["output"]>;
  filterFields: Array<Scalars["String"]["output"]>;
  hasNextPage: Scalars["Boolean"]["output"];
  hasPreviousPage: Scalars["Boolean"]["output"];
  sortFields: Array<Scalars["String"]["output"]>;
  startCursor?: Maybe<Scalars["Int"]["output"]>;
  totalItems?: Maybe<Scalars["Int"]["output"]>;
};

/** Information about a service on a port */
export type PortServiceType = {
  __typename?: "PortServiceType";
  description: Scalars["String"]["output"];
  percentage: Scalars["Float"]["output"];
  productType: Scalars["String"]["output"];
  speed: Scalars["Int"]["output"];
  subscriptionId: Scalars["String"]["output"];
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type PortSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of port results */
export type PortSubscriptionSort = {
  amountReserved?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  portMode?: InputMaybe<SortOrder>;
  portSpeed?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

export type PrivateQuery = {
  __typename?: "PrivateQuery";
  /** Return aggsp details */
  aggspDetails: AggspSubscriptionDetailsType;
  /** Returns a list of AIRT Scans */
  airtScans: AirtScanConnection;
  /** Grouped subscription counts */
  counts: Counts;
  /** Get all subscriptions */
  customerSubscriptions: Array<SubscriptionType>;
  /** Returns a list of DNS Firewall logs */
  dnsFirewallLogs: DnsFirewallTypeConnection;
  /** Returns a list of evpn ptp subscriptions */
  evpnPtpList: LightPathSubscriptionTypeConnectionV2;
  /** Return firewall details */
  firewallDetails: FirewallSubscriptionDetailsType;
  /** Return a list of firewall subscriptions */
  firewallList: FirewallSubscriptionTypeConnectionV2;
  /** Return ip bgp details */
  ipBgpDetails: IpSubscriptionDetailsType;
  /** Return IP list */
  ipList: IpSubscriptionListTypeConnectionV2;
  /** Return ip prefix ddos list */
  ipPrefixDdos: IpPrefixDdosTypeConnectionV2;
  /** Return ip prefix list */
  ipPrefixList: IpPrefixSubscriptionTypeConnectionV2;
  /** Return ip static details */
  ipStaticDetails: IpSubscriptionDetailsType;
  /** Return irb details */
  irbDetails: IrbSubscriptionDetailsType;
  /** Return L2VPN details */
  l2vpnDetails: L2VpnSubscriptionDetailsType;
  /** Returns a list of l2vpn subscriptions */
  l2vpnList: L2VpnSubscriptionTypeConnectionV2;
  /** Return L2VPN details */
  l3vpnDetails: L3VpnSubscriptionDetailsType;
  /** Returns a list of l3vpn subscriptions */
  l3vpnList: L3VpnSubscriptionTypeConnectionV2;
  /** Return lightpath details */
  lpDetails: LightPathSubscriptionDetailsType;
  /** Return lightpath redundant details */
  lrDetails: LightPathSubscriptionDetailsType;
  /** Return major disruption notifications */
  majorDisruptionNotifications: Array<NotificationType>;
  /** Return msc details */
  mscDetails: MscSubscriptionDetailsType;
  /** Return all notifications */
  notifications: Array<NotificationType>;
  /** Returns a list of port subscriptions */
  portList: ServicePortSubscriptionTypeConnectionV2;
  /** Return service port details */
  servicePortDetails: ServicePortSubscriptionDetailsType;
  /** Return subscription_status */
  subscriptionStatus?: Maybe<SubscriptionStatus>;
  /** Return list subscriptions with surf_cert info */
  surfCertList: SurfCertTypeConnectionV2;
  /** Return wired details */
  wiredDetails: WiredSubscriptionDetailsType;
  /** Return a list of wired subscriptions */
  wiredList: WiredSubscriptionTypeConnectionV2;
  /** Return wireless details */
  wirelessDetails: WirelessSubscriptionDetailsType;
  /** Return a list of wireless subscriptions */
  wirelessList: WirelessSubscriptionTypeConnectionV2;
  /** Return open SURFwireless SNTT tickets across an organisation's wireless locations */
  wirelessOrganisationTickets: Array<WirelessTicketType>;
};

export type PrivateQueryAggspDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryAirtScansArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<SearchFilter>;
  sort?: InputMaybe<AirtSort>;
};

export type PrivateQueryCustomerSubscriptionsArgs = {
  customerId: Scalars["UUID"]["input"];
  products?: InputMaybe<Array<Scalars["String"]["input"]>>;
  statuses?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type PrivateQueryDnsFirewallLogsArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter: DnsFirewallSearchFilter;
  sort?: InputMaybe<DnsFirewallSort>;
};

export type PrivateQueryEvpnPtpListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<EvpnPtpSubscriptionFilter>;
  sort?: InputMaybe<EvpnPtpSubscriptionSort>;
};

export type PrivateQueryFirewallDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryFirewallListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<FirewallSubscriptionFilter>;
  sort?: InputMaybe<FirewallSubscriptionSort>;
};

export type PrivateQueryIpBgpDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryIpListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<BaseSubscriptionFilter>;
  sort?: InputMaybe<BaseSubscriptionSort>;
};

export type PrivateQueryIpPrefixDdosArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<IpPrefixSubscriptionDdosFilter>;
  sort?: InputMaybe<IpPrefixSubscriptionDdosSort>;
};

export type PrivateQueryIpPrefixListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<IpPrefixSubscriptionFilter>;
  sort?: InputMaybe<IpPrefixSubscriptionSort>;
};

export type PrivateQueryIpStaticDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryIrbDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryL2vpnDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryL2vpnListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<L2VpnSubscriptionFilter>;
  sort?: InputMaybe<L2VpnSubscriptionSort>;
};

export type PrivateQueryL3vpnDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryL3vpnListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<L3VpnSubscriptionFilter>;
  sort?: InputMaybe<L3VpnSubscriptionSort>;
};

export type PrivateQueryLpDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryLrDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryMajorDisruptionNotificationsArgs = {
  searchFilter: MajorDisruptionNotificationFilter;
};

export type PrivateQueryMscDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryNotificationsArgs = {
  searchFilter: NotificationFilter;
};

export type PrivateQueryPortListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<PortSubscriptionFilter>;
  sort?: InputMaybe<PortSubscriptionSort>;
};

export type PrivateQueryServicePortDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQuerySubscriptionStatusArgs = {
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQuerySurfCertListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<SurfCertFilter>;
  sort?: InputMaybe<SurfCertSort>;
};

export type PrivateQueryWiredDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryWiredListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<WiredSubscriptionFilter>;
  sort?: InputMaybe<WiredSubscriptionSort>;
};

export type PrivateQueryWirelessDetailsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  subscriptionId: Scalars["UUID"]["input"];
};

export type PrivateQueryWirelessListArgs = {
  after?: Scalars["Int"]["input"];
  explain?: Scalars["Boolean"]["input"];
  first?: Scalars["Int"]["input"];
  searchFilter?: InputMaybe<WirelessSubscriptionFilter>;
  sort?: InputMaybe<WirelessSubscriptionSort>;
};

export type PrivateQueryWirelessOrganisationTicketsArgs = {
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
};

export enum ProcessState {
  Aborted = "ABORTED",
  Closed = "CLOSED",
  ClosedWithoutInform = "CLOSED_WITHOUT_INFORM",
  New = "NEW",
  Open = "OPEN",
  OpenAccepted = "OPEN_ACCEPTED",
  OpenRelated = "OPEN_RELATED",
  Updated = "UPDATED",
}

/** Information about product */
export type ProductType = {
  __typename?: "ProductType";
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  tag: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

/** Metadata to reference customer specific ID's */
export type ReferenceType = {
  __typename?: "ReferenceType";
  externalId: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

/** Filter airt scans by attribute, all ranges are inclusive */
export type SearchFilter = {
  /** Return results after import date */
  afterImportedDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Return results after observation date */
  afterObservationDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Return results after source date */
  afterSourceDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Search on application. E.g. ftp, ssh */
  application?: InputMaybe<Scalars["String"]["input"]>;
  /** Return results before import date */
  beforeImportedDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Return results before observation date */
  beforeObservationDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Return results before date */
  beforeSourceDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Case insensitive search on city */
  city?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by classification key/value pairs */
  classification?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search on IP address */
  ip?: InputMaybe<Scalars["String"]["input"]>;
  /** Return results filtered before destination IP */
  ipDestinationEnd?: InputMaybe<Scalars["String"]["input"]>;
  /** Return results filtered before destination IP */
  ipDestinationStart?: InputMaybe<Scalars["String"]["input"]>;
  /** Search on IP address */
  ipPrefixesDestination?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Search on IP address */
  ipPrefixesSource?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Return results filtered before source IP */
  ipSourceEnd?: InputMaybe<Scalars["String"]["input"]>;
  /** Return results filtered after source IP */
  ipSourceStart?: InputMaybe<Scalars["String"]["input"]>;
  /** Search on protocol: TCP/UDP/ICMP */
  protocol?: InputMaybe<Scalars["String"]["input"]>;
  /** Case insensitive on region */
  region?: InputMaybe<Scalars["String"]["input"]>;
  /** The severity of the case. */
  severity?: InputMaybe<Array<Severity>>;
};

/** Information about service attach point */
export type ServiceAttachPointType = {
  __typename?: "ServiceAttachPointType";
  address?: Maybe<AddressType>;
  name: Scalars["String"]["output"];
  organisation?: Maybe<Scalars["String"]["output"]>;
  ownerSubscriptionId: Scalars["UUID"]["output"];
  port?: Maybe<ServicePortSubscriptionType>;
  portSubscriptionId: Scalars["UUID"]["output"];
  subscriptionInstanceId: Scalars["UUID"]["output"];
  tag: Scalars["String"]["output"];
  vlanrange: Scalars["String"]["output"];
};

/** Information about port */
export type ServicePortSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "ServicePortSubscriptionDetailsType";
  address?: Maybe<AddressType>;
  aggregateParent?: Maybe<AggregateParentType>;
  amountReserved: Scalars["Int"]["output"];
  autoNegotiation?: Maybe<Scalars["Boolean"]["output"]>;
  connectorType?: Maybe<Scalars["String"]["output"]>;
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  fiberType?: Maybe<Scalars["String"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  ieeeInterfaceType?: Maybe<Scalars["String"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  locationDescription?: Maybe<Scalars["String"]["output"]>;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  patchPosition?: Maybe<Scalars["String"]["output"]>;
  portMode?: Maybe<Scalars["String"]["output"]>;
  portSpeed?: Maybe<Scalars["Int"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  services?: Maybe<Array<ServiceType>>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  surfLocationCode?: Maybe<Scalars["String"]["output"]>;
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

/** Information about port */
export type ServicePortSubscriptionType = {
  __typename?: "ServicePortSubscriptionType";
  address?: Maybe<AddressType>;
  amountReserved: Scalars["Int"]["output"];
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locationDescription?: Maybe<Scalars["String"]["output"]>;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  portMode: Scalars["String"]["output"];
  portSpeed: Scalars["Int"]["output"];
  product: ProductType;
  references: Array<ReferenceType>;
  services: Array<ServiceType>;
  speed?: Maybe<Scalars["String"]["output"]>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
  usedVlans: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type ServicePortSubscriptionTypeConnectionV2 = {
  __typename?: "ServicePortSubscriptionTypeConnectionV2";
  page: Array<ServicePortSubscriptionType>;
  pageInfo: PageInfo;
};

/** information about service port services */
export type ServiceType = {
  __typename?: "ServiceType";
  amountReserved: Scalars["Int"]["output"];
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  insync: Scalars["Boolean"]["output"];
  organisation?: Maybe<Scalars["String"]["output"]>;
  percentage: Scalars["Float"]["output"];
  portSpeed?: Maybe<Scalars["Int"]["output"]>;
  portSubscriptionInstanceId: Scalars["UUID"]["output"];
  product: ProductType;
  sapSubscriptionInstanceId?: Maybe<Scalars["UUID"]["output"]>;
  services?: Maybe<Array<ServiceType>>;
  speed: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  vlanrange?: Maybe<Scalars["String"]["output"]>;
};

/** The severity of the item */
export enum Severity {
  Critical = "CRITICAL",
  High = "HIGH",
  Info = "INFO",
  Low = "LOW",
  Medium = "MEDIUM",
}

/** Sort direction: ascending or descending */
export enum SortOrder {
  Asc = "ASC",
  Desc = "DESC",
}

export type SubscriptionCount = {
  __typename?: "SubscriptionCount";
  all: Scalars["Int"]["output"];
  inactive: Scalars["Int"]["output"];
  malfunction: Scalars["Int"]["output"];
  notfound: Scalars["Int"]["output"];
  notraffic: Scalars["Int"]["output"];
  ok: Scalars["Int"]["output"];
  pending: Scalars["Int"]["output"];
  unknown: Scalars["Int"]["output"];
};

export type SubscriptionCountWithFirewallsEnabled = {
  __typename?: "SubscriptionCountWithFirewallsEnabled";
  all: Scalars["Int"]["output"];
  firewallsEnabled: Scalars["Int"]["output"];
  inactive: Scalars["Int"]["output"];
  malfunction: Scalars["Int"]["output"];
  notfound: Scalars["Int"]["output"];
  notraffic: Scalars["Int"]["output"];
  ok: Scalars["Int"]["output"];
  pending: Scalars["Int"]["output"];
  unknown: Scalars["Int"]["output"];
};

export type SubscriptionDetails = {
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export enum SubscriptionLifecycle {
  Active = "ACTIVE",
  Disabled = "DISABLED",
  Initial = "INITIAL",
  Migrating = "MIGRATING",
  Provisioning = "PROVISIONING",
  Terminated = "TERMINATED",
}

/** Subscription status */
export type SubscriptionStatus = {
  __typename?: "SubscriptionStatus";
  productTag?: Maybe<Scalars["String"]["output"]>;
  productType: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

/** Base subscription info */
export type SubscriptionType = {
  __typename?: "SubscriptionType";
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type SurfCertFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type SurfCertSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

/** Information about surfcert */
export type SurfCertType = {
  __typename?: "SurfCertType";
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  insync: Scalars["Boolean"]["output"];
  productTag: Scalars["String"]["output"];
  productType: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["String"]["output"];
  surfcertFilterEnabled: Scalars["Boolean"]["output"];
};

export type SurfCertTypeConnectionV2 = {
  __typename?: "SurfCertTypeConnectionV2";
  page: Array<SurfCertType>;
  pageInfo: PageInfo;
};

export enum TicketType {
  Incident = "INCIDENT",
  MajorDisruption = "MAJOR_DISRUPTION",
  PlannedWork = "PLANNED_WORK",
}

/** Information about topology object */
export type TopologyObjectType = {
  __typename?: "TopologyObjectType";
  customerDescription: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  otherSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  product?: Maybe<ProductType>;
  subscriptionInstanceId: Scalars["UUID"]["output"];
  topologyObjectType: Scalars["String"]["output"];
  vlanrange?: Maybe<Scalars["String"]["output"]>;
};

/** Information about uplink location */
export type UplinkLocationType = {
  __typename?: "UplinkLocationType";
  address?: Maybe<AddressType>;
  locationDescription?: Maybe<Scalars["String"]["output"]>;
};

export enum Urgency {
  High = "HIGH",
  Normal = "NORMAL",
}

/** Information about wired */
export type WiredSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "WiredSubscriptionDetailsType";
  customCustomerAbbreviation?: Maybe<Scalars["String"]["output"]>;
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  monitoringEnabled: Scalars["Boolean"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type WiredSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type WiredSubscriptionSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

/** Information about SURFwired */
export type WiredSubscriptionType = SubscriptionDetails & {
  __typename?: "WiredSubscriptionType";
  customCustomerAbbreviation?: Maybe<Scalars["String"]["output"]>;
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  monitoringEnabled: Scalars["Boolean"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type WiredSubscriptionTypeConnectionV2 = {
  __typename?: "WiredSubscriptionTypeConnectionV2";
  page: Array<WiredSubscriptionType>;
  pageInfo: PageInfo;
};

/** Information about wireless */
export type WirelessLocationActivityType = {
  __typename?: "WirelessLocationActivityType";
  activeAccessPoints?: Maybe<Scalars["Int"]["output"]>;
  address?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  inactiveAccessPoints?: Maybe<Scalars["Int"]["output"]>;
  institute?: Maybe<Scalars["String"]["output"]>;
  location?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

/** Information about wireless location */
export type WirelessLocationDetailsType = {
  __typename?: "WirelessLocationDetailsType";
  accessPoints: Array<AccessPointType>;
  activeAccessPoints?: Maybe<Scalars["Int"]["output"]>;
  address?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  inactiveAccessPoints?: Maybe<Scalars["Int"]["output"]>;
  institute?: Maybe<Scalars["String"]["output"]>;
  location?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

/** Information about wireless */
export type WirelessSubscriptionDetailsType = SubscriptionDetails & {
  __typename?: "WirelessSubscriptionDetailsType";
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  location?: Maybe<WirelessLocationDetailsType>;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  sensorPresent: Scalars["Boolean"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  supplier: Scalars["String"]["output"];
  tags: Array<Scalars["String"]["output"]>;
  tickets: Array<WirelessTicketType>;
  version: Scalars["Int"]["output"];
};

/** Filter subscriptions by attribute, all ranges are inclusive */
export type WirelessSubscriptionFilter = {
  /** Search subscriptions accessible to this customer */
  accessCustomerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by customer id */
  customerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by description */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Search by product id */
  productId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Search by status */
  status?: InputMaybe<SubscriptionLifecycle>;
  /** Search by subscription id */
  subscriptionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Sort ordering of results */
export type WirelessSubscriptionSort = {
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
};

/** Information about SURFwireless */
export type WirelessSubscriptionType = SubscriptionDetails & {
  __typename?: "WirelessSubscriptionType";
  customer?: Maybe<CustomerType>;
  customerDescription: Scalars["String"]["output"];
  customerId: Scalars["UUID"]["output"];
  description: Scalars["String"]["output"];
  dirty: Scalars["Boolean"]["output"];
  endDate?: Maybe<Scalars["Int"]["output"]>;
  healthSubscriptionId?: Maybe<Scalars["UUID"]["output"]>;
  insync: Scalars["Boolean"]["output"];
  jiraLocationId?: Maybe<Scalars["String"]["output"]>;
  location: WirelessLocationActivityType;
  locations: Array<LocationType>;
  minimalImpactNotification?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  organisation?: Maybe<Scalars["String"]["output"]>;
  product: ProductType;
  references: Array<ReferenceType>;
  sensorPresent: Scalars["Boolean"]["output"];
  startDate: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  subscriptionId: Scalars["UUID"]["output"];
  supplier: Scalars["String"]["output"];
  /** tags */
  tags: Array<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type WirelessSubscriptionTypeConnectionV2 = {
  __typename?: "WirelessSubscriptionTypeConnectionV2";
  page: Array<WirelessSubscriptionType>;
  pageInfo: PageInfo;
};

/** Status of a SURFwireless SNTT ticket */
export type WirelessTicketStatusType = {
  __typename?: "WirelessTicketStatusType";
  id: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
};

/** A SURFwireless SNTT (Jira) service ticket */
export type WirelessTicketType = {
  __typename?: "WirelessTicketType";
  created: Scalars["DateTime"]["output"];
  locations: Array<Scalars["String"]["output"]>;
  status: WirelessTicketStatusType;
  summary?: Maybe<Scalars["String"]["output"]>;
  ticketId: Scalars["String"]["output"];
};

export type GetAirtScansQueryVariables = Exact<{
  filter?: InputMaybe<SearchFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<AirtSort>;
}>;

export type GetAirtScansQuery = {
  __typename?: "PrivateQuery";
  airtScans: {
    __typename?: "AirtScanConnection";
    edges: Array<{
      __typename?: "AirtScanEdge";
      node: {
        __typename?: "AirtScan";
        id: string;
        importedAt: string;
        modelVersion: string;
        classification?: any | null;
        destination?: any | null;
        extra?: any | null;
        feed?: any | null;
        malware?: any | null;
        source?: any | null;
        time?: any | null;
        protocol?: any | null;
        numberOfHits?: number | null;
        lastSeen?: string | null;
        firstSeen?: string | null;
        severity?: string | null;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      endCursor?: number | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: number | null;
      totalItems?: number | null;
    };
  };
};

export type GetAirtScansClassificationProtocolQueryVariables = Exact<{
  filter?: InputMaybe<SearchFilter>;
}>;

export type GetAirtScansClassificationProtocolQuery = {
  __typename?: "PrivateQuery";
  airtScans: {
    __typename?: "AirtScanConnection";
    edges: Array<{
      __typename?: "AirtScanEdge";
      node: { __typename?: "AirtScan"; classification?: any | null; protocol?: any | null; severity?: string | null };
    }>;
  };
};

export type GetAirtScansCountQueryVariables = Exact<{
  filter?: InputMaybe<SearchFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetAirtScansCountQuery = {
  __typename?: "PrivateQuery";
  airtScans: {
    __typename?: "AirtScanConnection";
    edges: Array<{
      __typename?: "AirtScanEdge";
      node: {
        __typename?: "AirtScan";
        id: string;
        classification?: any | null;
        protocol?: any | null;
        severity?: string | null;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      endCursor?: number | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: number | null;
      totalItems?: number | null;
    };
  };
};

export type CertMitigationPrefixesQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type CertMitigationPrefixesQuery = {
  __typename?: "PrivateQuery";
  ipPrefixDdos: {
    __typename?: "IpPrefixDdosTypeConnectionV2";
    page: Array<{
      __typename?: "IpPrefixDdosType";
      subscriptionId: string;
      autoMitigation?: boolean | null;
      customerId: string;
      description: string;
      insync: boolean;
      prefix: string;
      status: string;
      version: number;
      afi: number;
      dirty?: boolean | null;
    }>;
  };
};

export type CimNotificationFragment = {
  __typename?: "NotificationType";
  category: Category;
  endDate?: any | null;
  heading: string;
  id: string;
  impact: string;
  planDate?: any | null;
  startDate?: any | null;
  status: string;
  summary: string;
  tags: Array<string>;
  type: TicketType;
  urgency: Urgency;
  updates: Array<{ __typename?: "NotificationUpdate"; language: Language; description: string; timestamp: any }>;
};

export type CimAffectedSubscriptionsFragment = {
  __typename?: "NotificationType";
  affectedSubscriptions?: Array<{
    __typename?: "AffectedSubscriptionType";
    subscriptionId: string;
    impactType: string;
    subscription: {
      __typename?: "ImpactedSubscriptionType";
      subscriptionId: string;
      customerId: string;
      description: string;
      customerDescription: string;
      product?: { __typename?: "ProductType"; type: string; name: string } | null;
    };
  }>;
};

export type CimNotificationsQueryVariables = Exact<{
  filter: NotificationFilter;
  includeAffectedSubscriptions?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CimNotificationsQuery = {
  __typename?: "PrivateQuery";
  notifications: Array<{
    __typename?: "NotificationType";
    category: Category;
    endDate?: any | null;
    heading: string;
    id: string;
    impact: string;
    planDate?: any | null;
    startDate?: any | null;
    status: string;
    summary: string;
    tags: Array<string>;
    type: TicketType;
    urgency: Urgency;
    updates: Array<{ __typename?: "NotificationUpdate"; language: Language; description: string; timestamp: any }>;
    affectedSubscriptions?: Array<{
      __typename?: "AffectedSubscriptionType";
      subscriptionId: string;
      impactType: string;
      subscription: {
        __typename?: "ImpactedSubscriptionType";
        subscriptionId: string;
        customerId: string;
        description: string;
        customerDescription: string;
        product?: { __typename?: "ProductType"; type: string; name: string } | null;
      };
    }>;
  }>;
};

export type CimNotificationsSubscriptionQueryVariables = Exact<{
  filter: NotificationFilter;
}>;

export type CimNotificationsSubscriptionQuery = {
  __typename?: "PrivateQuery";
  notifications: Array<{
    __typename?: "NotificationType";
    category: Category;
    endDate?: any | null;
    heading: string;
    id: string;
    impact: string;
    planDate?: any | null;
    startDate?: any | null;
    status: string;
    summary: string;
    tags: Array<string>;
    type: TicketType;
    urgency: Urgency;
    updates: Array<{ __typename?: "NotificationUpdate"; language: Language; description: string; timestamp: any }>;
  }>;
};

export type CimMajorDisruptionNotificationsQueryVariables = Exact<{
  filter: MajorDisruptionNotificationFilter;
}>;

export type CimMajorDisruptionNotificationsQuery = {
  __typename?: "PrivateQuery";
  majorDisruptionNotifications: Array<{
    __typename?: "NotificationType";
    category: Category;
    endDate?: any | null;
    heading: string;
    id: string;
    impact: string;
    planDate?: any | null;
    startDate?: any | null;
    status: string;
    summary: string;
    tags: Array<string>;
    type: TicketType;
    urgency: Urgency;
    updates: Array<{ __typename?: "NotificationUpdate"; language: Language; description: string; timestamp: any }>;
  }>;
};

export type CustomerWithMinimalImpactNotificationQueryQueryVariables = Exact<{
  customerId: Scalars["UUID"]["input"];
  products?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
}>;

export type CustomerWithMinimalImpactNotificationQueryQuery = {
  __typename?: "PrivateQuery";
  customerSubscriptions: Array<{
    __typename?: "SubscriptionType";
    subscriptionId: string;
    minimalImpactNotification?: string | null;
    description: string;
    customerDescription: string;
    product: { __typename?: "ProductType"; type: string };
  }>;
};

export type GetDnsFirewallQueryVariables = Exact<{
  filter?: InputMaybe<DnsFirewallSearchFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<DnsFirewallSort>;
}>;

export type GetDnsFirewallQuery = {
  __typename?: "PrivateQuery";
  dnsFirewallLogs: {
    __typename?: "DNSFirewallTypeConnection";
    edges: Array<{
      __typename?: "DNSFirewallTypeEdge";
      cursor: number;
      node: {
        __typename?: "DNSFirewallType";
        customerId: string;
        ipAddress: string;
        rpzFeed: string;
        hit: string;
        recordedAt?: any | null;
        resolver: string;
        action: string;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      endCursor?: number | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: number | null;
      totalItems?: number | null;
    };
  };
};

export type PaginationInfoFragment = {
  __typename?: "PageInfo";
  endCursor?: number | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor?: number | null;
  totalItems?: number | null;
};

type BaseSubscriptionFragment_AggspSubscriptionDetailsType_Fragment = {
  __typename?: "AggspSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

type BaseSubscriptionFragment_FirewallSubscriptionDetailsType_Fragment = {
  __typename?: "FirewallSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

type BaseSubscriptionFragment_FirewallSubscriptionType_Fragment = {
  __typename?: "FirewallSubscriptionType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

type BaseSubscriptionFragment_IpPrefixSubscriptionType_Fragment = {
  __typename?: "IpPrefixSubscriptionType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

type BaseSubscriptionFragment_IpSubscriptionDetailsType_Fragment = {
  __typename?: "IpSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

type BaseSubscriptionFragment_IpSubscriptionListType_Fragment = {
  __typename?: "IpSubscriptionListType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

type BaseSubscriptionFragment_IrbSubscriptionDetailsType_Fragment = {
  __typename?: "IrbSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

type BaseSubscriptionFragment_L2VpnSubscriptionDetailsType_Fragment = {
  __typename?: "L2VPNSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

type BaseSubscriptionFragment_L3VpnSubscriptionDetailsType_Fragment = {
  __typename?: "L3VPNSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

type BaseSubscriptionFragment_LightPathSubscriptionDetailsType_Fragment = {
  __typename?: "LightPathSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

type BaseSubscriptionFragment_LightPathSubscriptionType_Fragment = {
  __typename?: "LightPathSubscriptionType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

type BaseSubscriptionFragment_MscSubscriptionDetailsType_Fragment = {
  __typename?: "MscSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

type BaseSubscriptionFragment_ServicePortSubscriptionDetailsType_Fragment = {
  __typename?: "ServicePortSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

type BaseSubscriptionFragment_WiredSubscriptionDetailsType_Fragment = {
  __typename?: "WiredSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

type BaseSubscriptionFragment_WiredSubscriptionType_Fragment = {
  __typename?: "WiredSubscriptionType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

type BaseSubscriptionFragment_WirelessSubscriptionDetailsType_Fragment = {
  __typename?: "WirelessSubscriptionDetailsType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

type BaseSubscriptionFragment_WirelessSubscriptionType_Fragment = {
  __typename?: "WirelessSubscriptionType";
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

export type BaseSubscriptionFragmentFragment =
  | BaseSubscriptionFragment_AggspSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_FirewallSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_FirewallSubscriptionType_Fragment
  | BaseSubscriptionFragment_IpPrefixSubscriptionType_Fragment
  | BaseSubscriptionFragment_IpSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_IpSubscriptionListType_Fragment
  | BaseSubscriptionFragment_IrbSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_L2VpnSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_L3VpnSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_LightPathSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_LightPathSubscriptionType_Fragment
  | BaseSubscriptionFragment_MscSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_ServicePortSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_WiredSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_WiredSubscriptionType_Fragment
  | BaseSubscriptionFragment_WirelessSubscriptionDetailsType_Fragment
  | BaseSubscriptionFragment_WirelessSubscriptionType_Fragment;

export type LinkedServicesFragmentFragment = {
  __typename?: "ServiceType";
  insync: boolean;
  subscriptionId: string;
  portSubscriptionInstanceId: string;
  sapSubscriptionInstanceId?: string | null;
  customerId: string;
  status: string;
  description: string;
  customerDescription: string;
  organisation?: string | null;
  speed: number;
  percentage: number;
  vlanrange?: string | null;
  portSpeed?: number | null;
  amountReserved: number;
  product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
  services?: Array<{
    __typename?: "ServiceType";
    description: string;
    percentage: number;
    speed: number;
    product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
  }> | null;
};

export type MinifiedLinkedServicesFragmentFragment = {
  __typename?: "ServiceType";
  subscriptionId: string;
  portSubscriptionInstanceId: string;
  sapSubscriptionInstanceId?: string | null;
  description: string;
  customerDescription: string;
  status: string;
  speed: number;
  percentage: number;
  vlanrange?: string | null;
  product: { __typename?: "ProductType"; type: string; tag: string; id: string; name: string };
};

type SubscriptionListBaseFragment_AggspSubscriptionDetailsType_Fragment = {
  __typename?: "AggspSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

type SubscriptionListBaseFragment_FirewallSubscriptionDetailsType_Fragment = {
  __typename?: "FirewallSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

type SubscriptionListBaseFragment_FirewallSubscriptionType_Fragment = {
  __typename?: "FirewallSubscriptionType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

type SubscriptionListBaseFragment_IpPrefixSubscriptionType_Fragment = {
  __typename?: "IpPrefixSubscriptionType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

type SubscriptionListBaseFragment_IpSubscriptionDetailsType_Fragment = {
  __typename?: "IpSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

type SubscriptionListBaseFragment_IpSubscriptionListType_Fragment = {
  __typename?: "IpSubscriptionListType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

type SubscriptionListBaseFragment_IrbSubscriptionDetailsType_Fragment = {
  __typename?: "IrbSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

type SubscriptionListBaseFragment_L2VpnSubscriptionDetailsType_Fragment = {
  __typename?: "L2VPNSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

type SubscriptionListBaseFragment_L3VpnSubscriptionDetailsType_Fragment = {
  __typename?: "L3VPNSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

type SubscriptionListBaseFragment_LightPathSubscriptionDetailsType_Fragment = {
  __typename?: "LightPathSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

type SubscriptionListBaseFragment_LightPathSubscriptionType_Fragment = {
  __typename?: "LightPathSubscriptionType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

type SubscriptionListBaseFragment_MscSubscriptionDetailsType_Fragment = {
  __typename?: "MscSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

type SubscriptionListBaseFragment_ServicePortSubscriptionDetailsType_Fragment = {
  __typename?: "ServicePortSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

type SubscriptionListBaseFragment_WiredSubscriptionDetailsType_Fragment = {
  __typename?: "WiredSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

type SubscriptionListBaseFragment_WiredSubscriptionType_Fragment = {
  __typename?: "WiredSubscriptionType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

type SubscriptionListBaseFragment_WirelessSubscriptionDetailsType_Fragment = {
  __typename?: "WirelessSubscriptionDetailsType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

type SubscriptionListBaseFragment_WirelessSubscriptionType_Fragment = {
  __typename?: "WirelessSubscriptionType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

export type SubscriptionListBaseFragmentFragment =
  | SubscriptionListBaseFragment_AggspSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_FirewallSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_FirewallSubscriptionType_Fragment
  | SubscriptionListBaseFragment_IpPrefixSubscriptionType_Fragment
  | SubscriptionListBaseFragment_IpSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_IpSubscriptionListType_Fragment
  | SubscriptionListBaseFragment_IrbSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_L2VpnSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_L3VpnSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_LightPathSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_LightPathSubscriptionType_Fragment
  | SubscriptionListBaseFragment_MscSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_ServicePortSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_WiredSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_WiredSubscriptionType_Fragment
  | SubscriptionListBaseFragment_WirelessSubscriptionDetailsType_Fragment
  | SubscriptionListBaseFragment_WirelessSubscriptionType_Fragment;

export type L2VpnListBaseFragmentFragment = {
  __typename?: "L2VpnSubscriptionType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

export type L3VpnListBaseFragmentFragment = {
  __typename?: "L3VpnSubscriptionType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

export type PortListBaseFragmentFragment = {
  __typename?: "ServicePortSubscriptionType";
  subscriptionId: string;
  healthSubscriptionId?: string | null;
  description: string;
  tags: Array<string>;
  status: string;
  customerDescription: string;
  customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

export type ServiceTypeFragmentFragment = {
  __typename?: "ServiceType";
  subscriptionId: string;
  portSubscriptionInstanceId: string;
  speed: number;
  percentage: number;
  description: string;
  product: { __typename?: "ProductType"; type: string; tag: string };
};

export type PortServiceTypeFragmentFragment = {
  __typename?: "PortServiceType";
  subscriptionId: string;
  productType: string;
  speed: number;
  percentage: number;
  description: string;
};

export type PortAccessCustomerListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type PortAccessCustomerListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "ServicePortSubscriptionTypeConnectionV2";
    page: Array<{
      __typename?: "ServicePortSubscriptionType";
      portSpeed: number;
      portMode: string;
      speed?: string | null;
      amountReserved: number;
      subscriptionId: string;
      healthSubscriptionId?: string | null;
      description: string;
      tags: Array<string>;
      status: string;
      customerDescription: string;
      services: Array<{
        __typename?: "ServiceType";
        subscriptionId: string;
        portSubscriptionInstanceId: string;
        speed: number;
        percentage: number;
        description: string;
        product: { __typename?: "ProductType"; type: string; tag: string };
      }>;
      locations: Array<{
        __typename?: "LocationType";
        address?: {
          __typename?: "AddressType";
          city?: string | null;
          number?: string | null;
          street?: string | null;
          addition?: string | null;
        } | null;
      }>;
      customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
      product: { __typename?: "ProductType"; type: string; tag: string };
    }>;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type PortCustomerListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type PortCustomerListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "ServicePortSubscriptionTypeConnectionV2";
    page: Array<{
      __typename?: "ServicePortSubscriptionType";
      portSpeed: number;
      portMode: string;
      speed?: string | null;
      amountReserved: number;
      usedVlans: Array<string>;
      subscriptionId: string;
      healthSubscriptionId?: string | null;
      description: string;
      tags: Array<string>;
      status: string;
      customerDescription: string;
      services: Array<{
        __typename?: "ServiceType";
        subscriptionId: string;
        portSubscriptionInstanceId: string;
        speed: number;
        percentage: number;
        description: string;
        product: { __typename?: "ProductType"; type: string; tag: string };
      }>;
      address?: { __typename?: "AddressType"; city?: string | null; street?: string | null } | null;
      customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
      product: { __typename?: "ProductType"; type: string; tag: string };
    }>;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type L3vpnListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type L3vpnListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "L3VpnSubscriptionTypeConnectionV2";
    page: Array<{
      __typename: "L3VpnSubscriptionType";
      firewallEnabled: boolean;
      subscriptionId: string;
      healthSubscriptionId?: string | null;
      description: string;
      tags: Array<string>;
      status: string;
      customerDescription: string;
      locations: Array<{
        __typename?: "LocationType";
        address?: {
          __typename?: "AddressType";
          city?: string | null;
          number?: string | null;
          street?: string | null;
          addition?: string | null;
        } | null;
      }>;
      customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
      product: { __typename?: "ProductType"; type: string; tag: string };
    }>;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type L2vpnListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type L2vpnListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "L2VpnSubscriptionTypeConnectionV2";
    page: Array<{
      __typename: "L2VpnSubscriptionType";
      firewallEnabled: boolean;
      subscriptionId: string;
      healthSubscriptionId?: string | null;
      description: string;
      tags: Array<string>;
      status: string;
      customerDescription: string;
      locations: Array<{
        __typename?: "LocationType";
        address?: {
          __typename?: "AddressType";
          city?: string | null;
          number?: string | null;
          street?: string | null;
          addition?: string | null;
        } | null;
      }>;
      customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
      product: { __typename?: "ProductType"; type: string; tag: string };
    }>;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type LightPathListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type LightPathListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "LightPathSubscriptionTypeConnectionV2";
    page: Array<{
      __typename: "LightPathSubscriptionType";
      subscriptionId: string;
      healthSubscriptionId?: string | null;
      description: string;
      tags: Array<string>;
      status: string;
      customerDescription: string;
      locations: Array<{
        __typename?: "LocationType";
        address?: {
          __typename?: "AddressType";
          city?: string | null;
          number?: string | null;
          street?: string | null;
          addition?: string | null;
        } | null;
      }>;
      services: Array<{
        __typename?: "PortServiceType";
        subscriptionId: string;
        productType: string;
        speed: number;
        percentage: number;
        description: string;
      }>;
      customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
      product: { __typename?: "ProductType"; type: string; tag: string };
    }>;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type IpPrefixesListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type IpPrefixesListQueryQuery = {
  __typename?: "PrivateQuery";
  ipPrefixList: {
    __typename?: "IpPrefixSubscriptionTypeConnectionV2";
    page: Array<{
      __typename?: "IpPrefixSubscriptionType";
      subscriptionId: string;
      customerId: string;
      description: string;
      startDate: number;
      customerDescription: string;
      insync: boolean;
      subscriptionType: "IpPrefixSubscriptionType";
      ipPrefix?: { __typename?: "IpPrefixType"; afi: string; state: number; prefix: string } | null;
      ipSubscriptions: Array<{
        __typename?: "IPSubscriptionListItemType";
        subscriptionId: string;
        customerId: string;
        description: string;
        customerDescription: string;
        product: { __typename?: "ProductType"; type: string; tag: string };
      }>;
      availableIpSubscriptions: Array<{
        __typename?: "IPSubscriptionListItemType";
        subscriptionId: string;
        customerId: string;
        description: string;
        customerDescription: string;
        product: { __typename?: "ProductType"; type: string; tag: string };
      }>;
    }>;
  };
};

export type WirelessSubscriptionListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type WirelessSubscriptionListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "WirelessSubscriptionTypeConnectionV2";
    page: Array<{
      __typename: "WirelessSubscriptionType";
      name?: string | null;
      supplier: string;
      sensorPresent: boolean;
      jiraLocationId?: string | null;
      subscriptionId: string;
      healthSubscriptionId?: string | null;
      description: string;
      tags: Array<string>;
      status: string;
      customerDescription: string;
      location: { __typename?: "WirelessLocationActivityType"; city?: string | null };
      customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
      product: { __typename?: "ProductType"; type: string; tag: string };
    }>;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type WiredSubscriptionListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type WiredSubscriptionListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "WiredSubscriptionTypeConnectionV2";
    page: Array<{
      __typename: "WiredSubscriptionType";
      name?: string | null;
      monitoringEnabled: boolean;
      customCustomerAbbreviation?: string | null;
      subscriptionId: string;
      healthSubscriptionId?: string | null;
      description: string;
      tags: Array<string>;
      status: string;
      customerDescription: string;
      customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
      product: { __typename?: "ProductType"; type: string; tag: string };
    }>;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type IpListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type IpListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "IpSubscriptionListTypeConnectionV2";
    page: Array<{
      __typename?: "IpSubscriptionListType";
      protection: string;
      subscriptionId: string;
      healthSubscriptionId?: string | null;
      description: string;
      tags: Array<string>;
      status: string;
      customerDescription: string;
      locations: Array<{
        __typename?: "LocationType";
        address?: {
          __typename?: "AddressType";
          city?: string | null;
          number?: string | null;
          street?: string | null;
          addition?: string | null;
        } | null;
      }>;
      customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
      product: { __typename?: "ProductType"; type: string; tag: string };
    }>;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type FirewallListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type FirewallListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "FirewallSubscriptionTypeConnectionV2";
    page: Array<{
      __typename?: "FirewallSubscriptionType";
      subscriptionId: string;
      healthSubscriptionId?: string | null;
      description: string;
      tags: Array<string>;
      status: string;
      customerDescription: string;
      customer?: { __typename?: "CustomerType"; customerId: string; fullname: string } | null;
      product: { __typename?: "ProductType"; type: string; tag: string };
    }>;
    pageInfo: { __typename?: "PageInfo"; totalItems?: number | null };
  };
};

export type BaseSubscriptionsOfTypeQueryQueryVariables = Exact<{
  customerId: Scalars["UUID"]["input"];
  products?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
  statuses?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
}>;

export type BaseSubscriptionsOfTypeQueryQuery = {
  __typename?: "PrivateQuery";
  customerSubscriptions: Array<{
    __typename?: "SubscriptionType";
    subscriptionId: string;
    description: string;
    customerDescription: string;
    product: { __typename?: "ProductType"; type: string };
  }>;
};

export type SurfCertDdosItemsQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type SurfCertDdosItemsQuery = {
  __typename?: "PrivateQuery";
  surfCertList: {
    __typename?: "SurfCertTypeConnectionV2";
    page: Array<{
      __typename?: "SurfCertType";
      customerDescription: string;
      description: string;
      productType: string;
      status: string;
      subscriptionId: string;
      surfcertFilterEnabled: boolean;
    }>;
  };
};

export type WirelessListQueryQueryVariables = Exact<{
  customer: Scalars["UUID"]["input"];
}>;

export type WirelessListQueryQuery = {
  __typename?: "PrivateQuery";
  subscriptions: {
    __typename?: "WirelessSubscriptionTypeConnectionV2";
    page: Array<{
      __typename?: "WirelessSubscriptionType";
      subscriptionId: string;
      description: string;
      customerDescription: string;
      location: { __typename?: "WirelessLocationActivityType"; city?: string | null };
    }>;
  };
};

export type FirewallSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type FirewallSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  firewallDetails: {
    __typename?: "FirewallSubscriptionDetailsType";
    availabilityZone?: string | null;
    customerAsn?: any | null;
    domain: string;
    firewallEnabled: boolean;
    fwAsn: any;
    protection: string;
    serviceSpeed: number;
    customerId: string;
    description: string;
    endDate?: number | null;
    insync: boolean;
    name?: string | null;
    organisation?: string | null;
    startDate: number;
    status: string;
    subscriptionId: string;
    tags: Array<string>;
    customerDescription: string;
    minimalImpactNotification?: string | null;
    dirty: boolean;
    topology: Array<
      Array<{
        __typename?: "TopologyObjectType";
        customerDescription: string;
        otherSubscriptionId?: string | null;
        subscriptionInstanceId: string;
        topologyObjectType: string;
        vlanrange?: string | null;
        product?: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string } | null;
      }>
    >;
    ipGateway?: {
      __typename?: "IpGatewayType";
      ipv4Mtu?: number | null;
      ipv6Mtu?: number | null;
      serviceSpeed: number;
      subscriptionInstanceId?: string | null;
      surfcertFilter: string;
      ipPrefixes: Array<string>;
      sapSubscriptionInstanceIds: Array<string>;
    } | null;
    l3Endpoints: Array<{
      __typename?: "L3EndpointType";
      subscriptionId: string;
      customerId: string;
      description: string;
      organisation?: string | null;
      otherSubscriptionId?: string | null;
      subscriptionInstanceId?: string | null;
      tags: Array<string>;
      sapSubscriptionInstanceIds: Array<string>;
      product: { __typename?: "ProductType"; type: string; tag: string };
    }>;
    l2Endpoints: Array<{
      __typename?: "L2EndpointType";
      subscriptionId: string;
      customerId: string;
      description: string;
      ipv4PtpPrefixes: Array<number>;
      ipv6PtpPrefixes: Array<number>;
      organisation?: string | null;
      otherSubscriptionId?: string | null;
      subscriptionInstanceId?: string | null;
      tags: Array<string>;
      sapSubscriptionInstanceIds: Array<string>;
      product: { __typename?: "ProductType"; type: string; tag: string };
    }>;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
  };
};

export type IpSapPortDataFragment = {
  __typename?: "IPServiceAttachPointType";
  port?: {
    __typename?: "ServicePortSubscriptionType";
    amountReserved: number;
    description: string;
    domain: string;
    locationDescription?: string | null;
    portMode: string;
    portSpeed: number;
    speed?: string | null;
    status: string;
    subscriptionId: string;
    tags: Array<string>;
    customerDescription: string;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    customer?: { __typename?: "CustomerType"; fullname: string; customerId: string } | null;
    services: Array<{
      __typename?: "ServiceType";
      subscriptionId: string;
      portSubscriptionInstanceId: string;
      sapSubscriptionInstanceId?: string | null;
      description: string;
      customerDescription: string;
      status: string;
      speed: number;
      percentage: number;
      vlanrange?: string | null;
      product: { __typename?: "ProductType"; type: string; tag: string; id: string; name: string };
    }>;
    locations: Array<{
      __typename?: "LocationType";
      address?: {
        __typename?: "AddressType";
        addition?: string | null;
        city?: string | null;
        countryCode?: string | null;
        extraAddressLine?: string | null;
        number?: string | null;
        street?: string | null;
        zipcode?: string | null;
      } | null;
    }>;
  } | null;
};

export type IpSapDataFragment = {
  __typename?: "IPServiceAttachPointType";
  subscriptionInstanceId: string;
  bfd?: boolean | null;
  bfdMinimumInterval?: number | null;
  bfdMultiplier?: number | null;
  bgpExportPolicy?: string | null;
  bgpHashAlgorithm?: string | null;
  bgpPassword?: string | null;
  bgpSessionPriority?: string | null;
  gracefulRestart?: boolean | null;
  ipv4Mtu?: number | null;
  ipv6Mtu?: number | null;
  vlanrange: string;
  ipPrefixes: Array<string>;
  ipv4PointToPointPrefix?: {
    __typename?: "IpPointToPointPrefixType";
    clientFQDN: string;
    clientIpAddress: string;
    network: string;
    surfFQDN: string;
    surfIpAddress: string;
  } | null;
  ipv6PointToPointPrefix?: {
    __typename?: "IpPointToPointPrefixType";
    clientFQDN: string;
    clientIpAddress: string;
    network: string;
    surfFQDN: string;
    surfIpAddress: string;
  } | null;
  port?: {
    __typename?: "ServicePortSubscriptionType";
    amountReserved: number;
    description: string;
    domain: string;
    locationDescription?: string | null;
    portMode: string;
    portSpeed: number;
    speed?: string | null;
    status: string;
    subscriptionId: string;
    tags: Array<string>;
    customerDescription: string;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    customer?: { __typename?: "CustomerType"; fullname: string; customerId: string } | null;
    services: Array<{
      __typename?: "ServiceType";
      subscriptionId: string;
      portSubscriptionInstanceId: string;
      sapSubscriptionInstanceId?: string | null;
      description: string;
      customerDescription: string;
      status: string;
      speed: number;
      percentage: number;
      vlanrange?: string | null;
      product: { __typename?: "ProductType"; type: string; tag: string; id: string; name: string };
    }>;
    locations: Array<{
      __typename?: "LocationType";
      address?: {
        __typename?: "AddressType";
        addition?: string | null;
        city?: string | null;
        countryCode?: string | null;
        extraAddressLine?: string | null;
        number?: string | null;
        street?: string | null;
        zipcode?: string | null;
      } | null;
    }>;
  } | null;
};

export type IpBgpSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type IpBgpSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  ipBgpDetails: {
    __typename?: "IpSubscriptionDetailsType";
    domain: string;
    firewallEnabled?: boolean | null;
    ipRoutingType: string;
    protection: string;
    serviceSpeed: number;
    customerId: string;
    description: string;
    endDate?: number | null;
    insync: boolean;
    name?: string | null;
    organisation?: string | null;
    startDate: number;
    status: string;
    subscriptionId: string;
    tags: Array<string>;
    customerDescription: string;
    minimalImpactNotification?: string | null;
    dirty: boolean;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    ipss: { __typename?: "IpServiceSettingsType"; surfcertFilter: string; asn?: number | null };
    saps: Array<{
      __typename?: "IPServiceAttachPointType";
      subscriptionInstanceId: string;
      bfd?: boolean | null;
      bfdMinimumInterval?: number | null;
      bfdMultiplier?: number | null;
      bgpExportPolicy?: string | null;
      bgpHashAlgorithm?: string | null;
      bgpPassword?: string | null;
      bgpSessionPriority?: string | null;
      gracefulRestart?: boolean | null;
      ipv4Mtu?: number | null;
      ipv6Mtu?: number | null;
      vlanrange: string;
      ipPrefixes: Array<string>;
      ipv4PointToPointPrefix?: {
        __typename?: "IpPointToPointPrefixType";
        clientFQDN: string;
        clientIpAddress: string;
        network: string;
        surfFQDN: string;
        surfIpAddress: string;
      } | null;
      ipv6PointToPointPrefix?: {
        __typename?: "IpPointToPointPrefixType";
        clientFQDN: string;
        clientIpAddress: string;
        network: string;
        surfFQDN: string;
        surfIpAddress: string;
      } | null;
      port?: {
        __typename?: "ServicePortSubscriptionType";
        amountReserved: number;
        description: string;
        domain: string;
        locationDescription?: string | null;
        portMode: string;
        portSpeed: number;
        speed?: string | null;
        status: string;
        subscriptionId: string;
        tags: Array<string>;
        customerDescription: string;
        product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
        customer?: { __typename?: "CustomerType"; fullname: string; customerId: string } | null;
        services: Array<{
          __typename?: "ServiceType";
          subscriptionId: string;
          portSubscriptionInstanceId: string;
          sapSubscriptionInstanceId?: string | null;
          description: string;
          customerDescription: string;
          status: string;
          speed: number;
          percentage: number;
          vlanrange?: string | null;
          product: { __typename?: "ProductType"; type: string; tag: string; id: string; name: string };
        }>;
        locations: Array<{
          __typename?: "LocationType";
          address?: {
            __typename?: "AddressType";
            addition?: string | null;
            city?: string | null;
            countryCode?: string | null;
            extraAddressLine?: string | null;
            number?: string | null;
            street?: string | null;
            zipcode?: string | null;
          } | null;
        }>;
      } | null;
    }>;
    topology: Array<
      Array<{
        __typename?: "TopologyObjectType";
        topologyObjectType: string;
        otherSubscriptionId?: string | null;
        subscriptionInstanceId: string;
        vlanrange?: string | null;
        customerDescription: string;
        product?: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string } | null;
      }>
    >;
    references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
  };
};

export type IpStaticSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type IpStaticSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  ipStaticDetails: {
    __typename?: "IpSubscriptionDetailsType";
    serviceSpeed: number;
    firewallEnabled?: boolean | null;
    protection: string;
    domain: string;
    ipRoutingType: string;
    customerId: string;
    description: string;
    endDate?: number | null;
    insync: boolean;
    name?: string | null;
    organisation?: string | null;
    startDate: number;
    status: string;
    subscriptionId: string;
    tags: Array<string>;
    customerDescription: string;
    minimalImpactNotification?: string | null;
    dirty: boolean;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    ipss: { __typename?: "IpServiceSettingsType"; surfcertFilter: string; asn?: number | null };
    saps: Array<{
      __typename?: "IPServiceAttachPointType";
      subscriptionInstanceId: string;
      bfd?: boolean | null;
      bfdMinimumInterval?: number | null;
      bfdMultiplier?: number | null;
      bgpExportPolicy?: string | null;
      bgpHashAlgorithm?: string | null;
      bgpPassword?: string | null;
      bgpSessionPriority?: string | null;
      gracefulRestart?: boolean | null;
      ipv4Mtu?: number | null;
      ipv6Mtu?: number | null;
      vlanrange: string;
      ipPrefixes: Array<string>;
      ipv4PointToPointPrefix?: {
        __typename?: "IpPointToPointPrefixType";
        clientFQDN: string;
        clientIpAddress: string;
        network: string;
        surfFQDN: string;
        surfIpAddress: string;
      } | null;
      ipv6PointToPointPrefix?: {
        __typename?: "IpPointToPointPrefixType";
        clientFQDN: string;
        clientIpAddress: string;
        network: string;
        surfFQDN: string;
        surfIpAddress: string;
      } | null;
      port?: {
        __typename?: "ServicePortSubscriptionType";
        amountReserved: number;
        description: string;
        domain: string;
        locationDescription?: string | null;
        portMode: string;
        portSpeed: number;
        speed?: string | null;
        status: string;
        subscriptionId: string;
        tags: Array<string>;
        customerDescription: string;
        product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
        customer?: { __typename?: "CustomerType"; fullname: string; customerId: string } | null;
        services: Array<{
          __typename?: "ServiceType";
          subscriptionId: string;
          portSubscriptionInstanceId: string;
          sapSubscriptionInstanceId?: string | null;
          description: string;
          customerDescription: string;
          status: string;
          speed: number;
          percentage: number;
          vlanrange?: string | null;
          product: { __typename?: "ProductType"; type: string; tag: string; id: string; name: string };
        }>;
        locations: Array<{
          __typename?: "LocationType";
          address?: {
            __typename?: "AddressType";
            addition?: string | null;
            city?: string | null;
            countryCode?: string | null;
            extraAddressLine?: string | null;
            number?: string | null;
            street?: string | null;
            zipcode?: string | null;
          } | null;
        }>;
      } | null;
    }>;
    topology: Array<
      Array<{
        __typename?: "TopologyObjectType";
        customerDescription: string;
        otherSubscriptionId?: string | null;
        subscriptionInstanceId: string;
        topologyObjectType: string;
        vlanrange?: string | null;
        product?: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string } | null;
      }>
    >;
    references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
  };
};

export type IrbSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type IrbSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  irbDetails: {
    __typename?: "IrbSubscriptionDetailsType";
    label?: string | null;
    locationDescription?: string | null;
    surfLocationCode?: string | null;
    portSpeed?: number | null;
    portId?: number | null;
    portMode?: string | null;
    domain: string;
    amountReserved: number;
    subscriptionInstanceId?: string | null;
    portSubscription?: string | null;
    customerId: string;
    description: string;
    endDate?: number | null;
    insync: boolean;
    name?: string | null;
    organisation?: string | null;
    startDate: number;
    status: string;
    subscriptionId: string;
    tags: Array<string>;
    customerDescription: string;
    minimalImpactNotification?: string | null;
    dirty: boolean;
    address?: {
      __typename?: "AddressType";
      city?: string | null;
      street?: string | null;
      number?: string | null;
    } | null;
    services: Array<{
      __typename?: "ServiceType";
      insync: boolean;
      subscriptionId: string;
      portSubscriptionInstanceId: string;
      sapSubscriptionInstanceId?: string | null;
      customerId: string;
      status: string;
      description: string;
      customerDescription: string;
      organisation?: string | null;
      speed: number;
      percentage: number;
      vlanrange?: string | null;
      portSpeed?: number | null;
      amountReserved: number;
      product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
      services?: Array<{
        __typename?: "ServiceType";
        description: string;
        percentage: number;
        speed: number;
        product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
      }> | null;
    }>;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
  };
};

export type L2vpnSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type L2vpnSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  l2vpnDetails: {
    __typename?: "L2VPNSubscriptionDetailsType";
    firewallEnabled: boolean;
    domain: string;
    serviceSpeed: number;
    protection: string;
    speedPolicer: boolean;
    customerId: string;
    description: string;
    endDate?: number | null;
    insync: boolean;
    name?: string | null;
    organisation?: string | null;
    startDate: number;
    status: string;
    subscriptionId: string;
    tags: Array<string>;
    customerDescription: string;
    minimalImpactNotification?: string | null;
    dirty: boolean;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    circuits: Array<{
      __typename?: "L2VPNCircuitType";
      endpoints: Array<{
        __typename?: "ServiceAttachPointType";
        name: string;
        organisation?: string | null;
        subscriptionInstanceId: string;
        tag: string;
        vlanrange: string;
        port?: {
          __typename?: "ServicePortSubscriptionType";
          portMode: string;
          subscriptionId: string;
          tags: Array<string>;
          speed?: string | null;
          customerDescription: string;
          services: Array<{ __typename?: "ServiceType"; vlanrange?: string | null; insync: boolean }>;
        } | null;
        address?: {
          __typename?: "AddressType";
          city?: string | null;
          street?: string | null;
          number?: string | null;
        } | null;
      }>;
    }>;
    topology: Array<
      Array<{
        __typename?: "TopologyObjectType";
        customerDescription: string;
        otherSubscriptionId?: string | null;
        subscriptionInstanceId: string;
        topologyObjectType: string;
        vlanrange?: string | null;
        product?: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string } | null;
      }>
    >;
    saps: Array<{
      __typename?: "ServiceAttachPointType";
      subscriptionInstanceId: string;
      name: string;
      port?: {
        __typename?: "ServicePortSubscriptionType";
        subscriptionId: string;
        description: string;
        domain: string;
        portMode: string;
        portSpeed: number;
        amountReserved: number;
        speed?: string | null;
        status: string;
        tags: Array<string>;
        customerDescription: string;
        customer?: { __typename?: "CustomerType"; fullname: string; customerId: string } | null;
        product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
        services: Array<{
          __typename?: "ServiceType";
          subscriptionId: string;
          portSubscriptionInstanceId: string;
          sapSubscriptionInstanceId?: string | null;
          description: string;
          customerDescription: string;
          status: string;
          speed: number;
          percentage: number;
          vlanrange?: string | null;
          product: { __typename?: "ProductType"; type: string; tag: string; id: string; name: string };
        }>;
        locations: Array<{
          __typename?: "LocationType";
          address?: {
            __typename?: "AddressType";
            addition?: string | null;
            city?: string | null;
            countryCode?: string | null;
            extraAddressLine?: string | null;
            number?: string | null;
            street?: string | null;
            zipcode?: string | null;
          } | null;
        }>;
      } | null;
    }>;
    esis: Array<{
      __typename?: "EthernetSegmentIdentifierType";
      segmentId?: number | null;
      firewallInterconnect?: {
        __typename?: "L2InterconnectType";
        firewallSubscriptionId?: string | null;
        subscriptionInstanceId?: string | null;
      } | null;
      endpoints?: Array<{
        __typename?: "ServiceAttachPointType";
        subscriptionInstanceId: string;
        organisation?: string | null;
        name: string;
        tag: string;
        vlanrange: string;
        port?: {
          __typename?: "ServicePortSubscriptionType";
          subscriptionId: string;
          description: string;
          amountReserved: number;
          portSpeed: number;
          tags: Array<string>;
          customerDescription: string;
          usedVlans: Array<string>;
          customer?: { __typename?: "CustomerType"; fullname: string; customerId: string } | null;
          locations: Array<{
            __typename?: "LocationType";
            address?: {
              __typename?: "AddressType";
              addition?: string | null;
              city?: string | null;
              number?: string | null;
              street?: string | null;
            } | null;
          }>;
          address?: {
            __typename?: "AddressType";
            addition?: string | null;
            city?: string | null;
            countryCode?: string | null;
            extraAddressLine?: string | null;
            number?: string | null;
            street?: string | null;
            zipcode?: string | null;
          } | null;
          services: Array<{
            __typename?: "ServiceType";
            subscriptionId: string;
            portSubscriptionInstanceId: string;
            sapSubscriptionInstanceId?: string | null;
            description: string;
            customerDescription: string;
            status: string;
            speed: number;
            percentage: number;
            vlanrange?: string | null;
            product: { __typename?: "ProductType"; type: string; tag: string; id: string; name: string };
          }>;
          product: { __typename?: "ProductType"; id: string; type: string; tag: string };
        } | null;
      }> | null;
    }>;
    firewallInterconnects: Array<{
      __typename?: "L2InterconnectType";
      availabilityZone?: string | null;
      description: string;
      firewallSubscriptionId?: string | null;
      subscriptionInstanceId?: string | null;
      organisation?: string | null;
      customerId?: string | null;
      endpoints?: Array<{ __typename?: "ServiceAttachPointType"; subscriptionInstanceId: string }> | null;
    }>;
    references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
  };
};

export type L3vpnSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type L3vpnSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  l3vpnDetails: {
    __typename?: "L3VPNSubscriptionDetailsType";
    firewallEnabled: boolean;
    domain: string;
    insync: boolean;
    serviceSpeed: number;
    protection: string;
    speedPolicer: boolean;
    customerId: string;
    description: string;
    endDate?: number | null;
    name?: string | null;
    organisation?: string | null;
    startDate: number;
    status: string;
    subscriptionId: string;
    tags: Array<string>;
    customerDescription: string;
    minimalImpactNotification?: string | null;
    dirty: boolean;
    references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    circuits: Array<{
      __typename?: "L3VPNCircuitType";
      endpoints: Array<{
        __typename?: "ServiceAttachPointType";
        name: string;
        organisation?: string | null;
        subscriptionInstanceId: string;
        tag: string;
        vlanrange: string;
        port?: {
          __typename?: "ServicePortSubscriptionType";
          customerDescription: string;
          portMode: string;
          subscriptionId: string;
          tags: Array<string>;
          speed?: string | null;
          services: Array<{ __typename?: "ServiceType"; vlanrange?: string | null; insync: boolean }>;
        } | null;
        address?: {
          __typename?: "AddressType";
          city?: string | null;
          street?: string | null;
          number?: string | null;
        } | null;
      }>;
    }>;
    topology: Array<
      Array<{
        __typename?: "TopologyObjectType";
        customerDescription: string;
        otherSubscriptionId?: string | null;
        subscriptionInstanceId: string;
        topologyObjectType: string;
        vlanrange?: string | null;
        product?: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string } | null;
      }>
    >;
    l3vpnss: { __typename?: "L3VPNServiceSettingsType"; l3vpnAsn: number };
    l3vpnsapss: Array<{
      __typename?: "L3VPNSAPServiceSettingsType";
      subscriptionInstanceId: string;
      name: string;
      bfd?: boolean | null;
      bfdMinimumInterval?: number | null;
      bfdMultiplier?: number | null;
      bgpPassword?: string | null;
      ipv4Mtu?: number | null;
      ipv6Mtu?: number | null;
      bgpMetric?: string | null;
      ipv4Address?: string | null;
      ipv4MaxPrefix?: number | null;
      ipv6Address?: string | null;
      ipv4RemoteAddress?: string | null;
      ipv6MaxPrefix?: number | null;
      ipv6RemoteAddress?: string | null;
      sap: {
        __typename?: "ServiceAttachPointType";
        subscriptionInstanceId: string;
        vlanrange: string;
        port?: {
          __typename?: "ServicePortSubscriptionType";
          description: string;
          domain: string;
          portMode: string;
          portSpeed: number;
          amountReserved: number;
          speed?: string | null;
          status: string;
          subscriptionId: string;
          tags: Array<string>;
          customerDescription: string;
          product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
          customer?: { __typename?: "CustomerType"; fullname: string; customerId: string } | null;
          services: Array<{
            __typename?: "ServiceType";
            subscriptionId: string;
            portSubscriptionInstanceId: string;
            sapSubscriptionInstanceId?: string | null;
            description: string;
            customerDescription: string;
            status: string;
            speed: number;
            percentage: number;
            vlanrange?: string | null;
            product: { __typename?: "ProductType"; type: string; tag: string; id: string; name: string };
          }>;
          address?: {
            __typename?: "AddressType";
            addition?: string | null;
            city?: string | null;
            countryCode?: string | null;
            extraAddressLine?: string | null;
            number?: string | null;
            street?: string | null;
            zipcode?: string | null;
          } | null;
          locations: Array<{
            __typename?: "LocationType";
            address?: {
              __typename?: "AddressType";
              addition?: string | null;
              city?: string | null;
              countryCode?: string | null;
              extraAddressLine?: string | null;
              number?: string | null;
              street?: string | null;
              zipcode?: string | null;
            } | null;
          }>;
        } | null;
      };
    }>;
    firewallInterconnects: Array<{
      __typename?: "L3FwInterconnectType";
      availabilityZone: string;
      firewallAsn: string;
      ipv4Mtu?: number | null;
      ipv6Mtu?: number | null;
      ipv4Prefix?: any | null;
      ipv6Prefix?: any | null;
      ipv4MaxPrefix?: number | null;
      ipv6MaxPrefix?: number | null;
      ipv4AddressFirewall?: any | null;
      ipv6AddressFirewall?: any | null;
      firewallSubscriptionId: string;
      subscriptionInstanceId: string;
      organisation?: string | null;
      customerId: string;
      customerDescription: string;
      description: string;
      saps: Array<{
        __typename?: "ServiceAttachPointType";
        subscriptionInstanceId: string;
        name: string;
        tag: string;
        organisation?: string | null;
        vlanrange: string;
        address?: {
          __typename?: "AddressType";
          street?: string | null;
          number?: string | null;
          city?: string | null;
        } | null;
      }>;
    }>;
  };
};

export type LightPathSubscriptionDetailsFragmentFragment = {
  __typename?: "LightPathSubscriptionDetailsType";
  domain: string;
  protection: string;
  serviceId?: string | null;
  serviceSpeed: number;
  speedPolicer: boolean;
  customerId: string;
  description: string;
  endDate?: number | null;
  insync: boolean;
  name?: string | null;
  organisation?: string | null;
  startDate: number;
  status: string;
  subscriptionId: string;
  tags: Array<string>;
  customerDescription: string;
  minimalImpactNotification?: string | null;
  dirty: boolean;
  product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
  saps: Array<{
    __typename?: "ServiceAttachPointType";
    name: string;
    organisation?: string | null;
    subscriptionInstanceId: string;
    tag: string;
    vlanrange: string;
  }>;
  circuits: Array<{
    __typename?: "LightPathCircuitType";
    name: string;
    remotePortShutdown?: boolean | null;
    serviceId?: string | null;
    serviceSpeed?: number | null;
    subscriptionInstanceId: string;
    tag: string;
    endpoints: Array<{
      __typename?: "ServiceAttachPointType";
      name: string;
      organisation?: string | null;
      subscriptionInstanceId: string;
      tag: string;
      vlanrange: string;
      port?: {
        __typename?: "ServicePortSubscriptionType";
        amountReserved: number;
        customerDescription: string;
        description: string;
        domain: string;
        portMode: string;
        portSpeed: number;
        speed?: string | null;
        status: string;
        subscriptionId: string;
        tags: Array<string>;
        usedVlans: Array<string>;
        customer?: { __typename?: "CustomerType"; customerId: string } | null;
        product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
        services: Array<{
          __typename?: "ServiceType";
          insync: boolean;
          subscriptionId: string;
          portSubscriptionInstanceId: string;
          sapSubscriptionInstanceId?: string | null;
          customerId: string;
          status: string;
          description: string;
          customerDescription: string;
          organisation?: string | null;
          speed: number;
          percentage: number;
          vlanrange?: string | null;
          portSpeed?: number | null;
          amountReserved: number;
          product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
          services?: Array<{
            __typename?: "ServiceType";
            description: string;
            percentage: number;
            speed: number;
            product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
          }> | null;
        }>;
        address?: {
          __typename?: "AddressType";
          addition?: string | null;
          city?: string | null;
          countryCode?: string | null;
          extraAddressLine?: string | null;
          number?: string | null;
          street?: string | null;
          zipcode?: string | null;
        } | null;
      } | null;
    }>;
  }>;
  topology: Array<
    Array<{
      __typename?: "TopologyObjectType";
      customerDescription: string;
      otherSubscriptionId?: string | null;
      subscriptionInstanceId: string;
      topologyObjectType: string;
      vlanrange?: string | null;
      product?: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string } | null;
    }>
  >;
  references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
};

export type LightpathSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type LightpathSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  lpDetails: {
    __typename?: "LightPathSubscriptionDetailsType";
    domain: string;
    protection: string;
    serviceId?: string | null;
    serviceSpeed: number;
    speedPolicer: boolean;
    customerId: string;
    description: string;
    endDate?: number | null;
    insync: boolean;
    name?: string | null;
    organisation?: string | null;
    startDate: number;
    status: string;
    subscriptionId: string;
    tags: Array<string>;
    customerDescription: string;
    minimalImpactNotification?: string | null;
    dirty: boolean;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    saps: Array<{
      __typename?: "ServiceAttachPointType";
      name: string;
      organisation?: string | null;
      subscriptionInstanceId: string;
      tag: string;
      vlanrange: string;
    }>;
    circuits: Array<{
      __typename?: "LightPathCircuitType";
      name: string;
      remotePortShutdown?: boolean | null;
      serviceId?: string | null;
      serviceSpeed?: number | null;
      subscriptionInstanceId: string;
      tag: string;
      endpoints: Array<{
        __typename?: "ServiceAttachPointType";
        name: string;
        organisation?: string | null;
        subscriptionInstanceId: string;
        tag: string;
        vlanrange: string;
        port?: {
          __typename?: "ServicePortSubscriptionType";
          amountReserved: number;
          customerDescription: string;
          description: string;
          domain: string;
          portMode: string;
          portSpeed: number;
          speed?: string | null;
          status: string;
          subscriptionId: string;
          tags: Array<string>;
          usedVlans: Array<string>;
          customer?: { __typename?: "CustomerType"; customerId: string } | null;
          product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
          services: Array<{
            __typename?: "ServiceType";
            insync: boolean;
            subscriptionId: string;
            portSubscriptionInstanceId: string;
            sapSubscriptionInstanceId?: string | null;
            customerId: string;
            status: string;
            description: string;
            customerDescription: string;
            organisation?: string | null;
            speed: number;
            percentage: number;
            vlanrange?: string | null;
            portSpeed?: number | null;
            amountReserved: number;
            product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
            services?: Array<{
              __typename?: "ServiceType";
              description: string;
              percentage: number;
              speed: number;
              product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
            }> | null;
          }>;
          address?: {
            __typename?: "AddressType";
            addition?: string | null;
            city?: string | null;
            countryCode?: string | null;
            extraAddressLine?: string | null;
            number?: string | null;
            street?: string | null;
            zipcode?: string | null;
          } | null;
        } | null;
      }>;
    }>;
    topology: Array<
      Array<{
        __typename?: "TopologyObjectType";
        customerDescription: string;
        otherSubscriptionId?: string | null;
        subscriptionInstanceId: string;
        topologyObjectType: string;
        vlanrange?: string | null;
        product?: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string } | null;
      }>
    >;
    references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
  };
};

export type LightpathRedundantSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type LightpathRedundantSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  lrDetails: {
    __typename?: "LightPathSubscriptionDetailsType";
    domain: string;
    protection: string;
    serviceId?: string | null;
    serviceSpeed: number;
    speedPolicer: boolean;
    customerId: string;
    description: string;
    endDate?: number | null;
    insync: boolean;
    name?: string | null;
    organisation?: string | null;
    startDate: number;
    status: string;
    subscriptionId: string;
    tags: Array<string>;
    customerDescription: string;
    minimalImpactNotification?: string | null;
    dirty: boolean;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    saps: Array<{
      __typename?: "ServiceAttachPointType";
      name: string;
      organisation?: string | null;
      subscriptionInstanceId: string;
      tag: string;
      vlanrange: string;
    }>;
    circuits: Array<{
      __typename?: "LightPathCircuitType";
      name: string;
      remotePortShutdown?: boolean | null;
      serviceId?: string | null;
      serviceSpeed?: number | null;
      subscriptionInstanceId: string;
      tag: string;
      endpoints: Array<{
        __typename?: "ServiceAttachPointType";
        name: string;
        organisation?: string | null;
        subscriptionInstanceId: string;
        tag: string;
        vlanrange: string;
        port?: {
          __typename?: "ServicePortSubscriptionType";
          amountReserved: number;
          customerDescription: string;
          description: string;
          domain: string;
          portMode: string;
          portSpeed: number;
          speed?: string | null;
          status: string;
          subscriptionId: string;
          tags: Array<string>;
          usedVlans: Array<string>;
          customer?: { __typename?: "CustomerType"; customerId: string } | null;
          product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
          services: Array<{
            __typename?: "ServiceType";
            insync: boolean;
            subscriptionId: string;
            portSubscriptionInstanceId: string;
            sapSubscriptionInstanceId?: string | null;
            customerId: string;
            status: string;
            description: string;
            customerDescription: string;
            organisation?: string | null;
            speed: number;
            percentage: number;
            vlanrange?: string | null;
            portSpeed?: number | null;
            amountReserved: number;
            product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
            services?: Array<{
              __typename?: "ServiceType";
              description: string;
              percentage: number;
              speed: number;
              product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
            }> | null;
          }>;
          address?: {
            __typename?: "AddressType";
            addition?: string | null;
            city?: string | null;
            countryCode?: string | null;
            extraAddressLine?: string | null;
            number?: string | null;
            street?: string | null;
            zipcode?: string | null;
          } | null;
        } | null;
      }>;
    }>;
    topology: Array<
      Array<{
        __typename?: "TopologyObjectType";
        customerDescription: string;
        otherSubscriptionId?: string | null;
        subscriptionInstanceId: string;
        topologyObjectType: string;
        vlanrange?: string | null;
        product?: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string } | null;
      }>
    >;
    references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
  };
};

export type LinkMemberFragmentFragment = {
  __typename?: "LinkMemberDetailsType";
  subscriptionId: string;
  customerId: string;
  description: string;
  organisation?: string | null;
  customerDescription: string;
  vlanrange?: string | null;
  patchPosition?: string | null;
  ieeeInterfaceType?: string | null;
  portSpeed: number;
  amountReserved: number;
  tags: Array<string>;
  product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
  services: Array<{
    __typename?: "ServiceType";
    insync: boolean;
    subscriptionId: string;
    portSubscriptionInstanceId: string;
    sapSubscriptionInstanceId?: string | null;
    customerId: string;
    status: string;
    description: string;
    customerDescription: string;
    organisation?: string | null;
    speed: number;
    percentage: number;
    vlanrange?: string | null;
    portSpeed?: number | null;
    amountReserved: number;
    product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
    services?: Array<{
      __typename?: "ServiceType";
      description: string;
      percentage: number;
      speed: number;
      product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
    }> | null;
  }>;
};

export type AggspSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type AggspSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  aggspDetails: {
    __typename?: "AggspSubscriptionDetailsType";
    label?: string | null;
    locationDescription?: string | null;
    surfLocationCode?: string | null;
    portSpeed?: number | null;
    portId?: number | null;
    portMode?: string | null;
    domain: string;
    amountReserved: number;
    subscriptionInstanceId?: string | null;
    portSubscription?: string | null;
    customerId: string;
    description: string;
    endDate?: number | null;
    insync: boolean;
    name?: string | null;
    organisation?: string | null;
    startDate: number;
    status: string;
    subscriptionId: string;
    tags: Array<string>;
    customerDescription: string;
    minimalImpactNotification?: string | null;
    dirty: boolean;
    linkMemberSubscriptions: Array<{
      __typename?: "LinkMemberDetailsType";
      subscriptionId: string;
      customerId: string;
      description: string;
      organisation?: string | null;
      customerDescription: string;
      vlanrange?: string | null;
      patchPosition?: string | null;
      ieeeInterfaceType?: string | null;
      portSpeed: number;
      amountReserved: number;
      tags: Array<string>;
      product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
      services: Array<{
        __typename?: "ServiceType";
        insync: boolean;
        subscriptionId: string;
        portSubscriptionInstanceId: string;
        sapSubscriptionInstanceId?: string | null;
        customerId: string;
        status: string;
        description: string;
        customerDescription: string;
        organisation?: string | null;
        speed: number;
        percentage: number;
        vlanrange?: string | null;
        portSpeed?: number | null;
        amountReserved: number;
        product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
        services?: Array<{
          __typename?: "ServiceType";
          description: string;
          percentage: number;
          speed: number;
          product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
        }> | null;
      }>;
    }>;
    address?: {
      __typename?: "AddressType";
      city?: string | null;
      street?: string | null;
      number?: string | null;
    } | null;
    services?: Array<{
      __typename?: "ServiceType";
      insync: boolean;
      subscriptionId: string;
      portSubscriptionInstanceId: string;
      sapSubscriptionInstanceId?: string | null;
      customerId: string;
      status: string;
      description: string;
      customerDescription: string;
      organisation?: string | null;
      speed: number;
      percentage: number;
      vlanrange?: string | null;
      portSpeed?: number | null;
      amountReserved: number;
      product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
      services?: Array<{
        __typename?: "ServiceType";
        description: string;
        percentage: number;
        speed: number;
        product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
      }> | null;
    }> | null;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
  };
};

export type MscSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type MscSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  mscDetails: {
    __typename?: "MscSubscriptionDetailsType";
    label?: string | null;
    locationDescription?: string | null;
    surfLocationCode?: string | null;
    portSpeed?: number | null;
    portId?: number | null;
    portMode?: string | null;
    domain: string;
    amountReserved: number;
    subscriptionInstanceId?: string | null;
    serviceTag?: number | null;
    customerId: string;
    description: string;
    endDate?: number | null;
    insync: boolean;
    name?: string | null;
    organisation?: string | null;
    startDate: number;
    status: string;
    subscriptionId: string;
    tags: Array<string>;
    customerDescription: string;
    minimalImpactNotification?: string | null;
    dirty: boolean;
    address?: {
      __typename?: "AddressType";
      city?: string | null;
      street?: string | null;
      number?: string | null;
    } | null;
    portSubscription?: {
      __typename?: "MscPortSubscriptionType";
      subscriptionId: string;
      customerId: string;
      description: string;
    } | null;
    services: Array<{
      __typename?: "ServiceType";
      insync: boolean;
      subscriptionId: string;
      portSubscriptionInstanceId: string;
      sapSubscriptionInstanceId?: string | null;
      customerId: string;
      status: string;
      description: string;
      customerDescription: string;
      organisation?: string | null;
      speed: number;
      percentage: number;
      vlanrange?: string | null;
      portSpeed?: number | null;
      amountReserved: number;
      product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
      services?: Array<{
        __typename?: "ServiceType";
        description: string;
        percentage: number;
        speed: number;
        product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
      }> | null;
    }>;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
  };
};

export type PortSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type PortSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  servicePortDetails: {
    __typename: "ServicePortSubscriptionDetailsType";
    label?: string | null;
    locationDescription?: string | null;
    surfLocationCode?: string | null;
    portSpeed?: number | null;
    portMode?: string | null;
    autoNegotiation?: boolean | null;
    patchPosition?: string | null;
    fiberType?: string | null;
    connectorType?: string | null;
    ieeeInterfaceType?: string | null;
    domain: string;
    amountReserved: number;
    customerId: string;
    description: string;
    endDate?: number | null;
    insync: boolean;
    name?: string | null;
    organisation?: string | null;
    startDate: number;
    status: string;
    subscriptionId: string;
    tags: Array<string>;
    customerDescription: string;
    minimalImpactNotification?: string | null;
    dirty: boolean;
    address?: {
      __typename?: "AddressType";
      city?: string | null;
      street?: string | null;
      number?: string | null;
    } | null;
    services?: Array<{
      __typename?: "ServiceType";
      insync: boolean;
      subscriptionId: string;
      portSubscriptionInstanceId: string;
      sapSubscriptionInstanceId?: string | null;
      customerId: string;
      status: string;
      description: string;
      customerDescription: string;
      organisation?: string | null;
      speed: number;
      percentage: number;
      vlanrange?: string | null;
      portSpeed?: number | null;
      amountReserved: number;
      product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
      services?: Array<{
        __typename?: "ServiceType";
        description: string;
        percentage: number;
        speed: number;
        product: { __typename?: "ProductType"; id: string; name: string; type: string; tag: string };
      }> | null;
    }> | null;
    aggregateParent?: {
      __typename?: "AggregateParentType";
      subscriptionId: string;
      customerDescription: string;
    } | null;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
  };
};

export type WiredSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type WiredSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  wiredDetails: {
    __typename?: "WiredSubscriptionDetailsType";
    monitoringEnabled: boolean;
    customCustomerAbbreviation?: string | null;
    customerId: string;
    description: string;
    endDate?: number | null;
    insync: boolean;
    name?: string | null;
    organisation?: string | null;
    startDate: number;
    status: string;
    subscriptionId: string;
    tags: Array<string>;
    customerDescription: string;
    minimalImpactNotification?: string | null;
    dirty: boolean;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
  };
};

export type WirelessSubscriptionDetailsQueryVariables = Exact<{
  subscriptionId: Scalars["UUID"]["input"];
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type WirelessSubscriptionDetailsQuery = {
  __typename?: "PrivateQuery";
  wirelessDetails: {
    __typename?: "WirelessSubscriptionDetailsType";
    sensorPresent: boolean;
    supplier: string;
    customerId: string;
    description: string;
    endDate?: number | null;
    insync: boolean;
    name?: string | null;
    organisation?: string | null;
    startDate: number;
    status: string;
    subscriptionId: string;
    tags: Array<string>;
    customerDescription: string;
    minimalImpactNotification?: string | null;
    dirty: boolean;
    location?: {
      __typename?: "WirelessLocationDetailsType";
      city?: string | null;
      country?: string | null;
      address?: string | null;
      accessPoints: Array<{
        __typename?: "AccessPointType";
        brand?: string | null;
        model?: string | null;
        supplier?: string | null;
        ciStatus?: string | null;
      }>;
    } | null;
    tickets: Array<{
      __typename?: "WirelessTicketType";
      ticketId: string;
      summary?: string | null;
      created: any;
      locations: Array<string>;
      status: { __typename?: "WirelessTicketStatusType"; id: number; name: string };
    }>;
    product: { __typename?: "ProductType"; id: string; name: string; tag: string; type: string };
    references: Array<{ __typename?: "ReferenceType"; externalId: string; name: string }>;
  };
};

export type WirelessOrganisationTicketsQueryVariables = Exact<{
  accessCustomerId: Scalars["UUID"]["input"];
}>;

export type WirelessOrganisationTicketsQuery = {
  __typename?: "PrivateQuery";
  wirelessOrganisationTickets: Array<{
    __typename?: "WirelessTicketType";
    ticketId: string;
    summary?: string | null;
    created: any;
    locations: Array<string>;
    status: { __typename?: "WirelessTicketStatusType"; id: number; name: string };
  }>;
};

export const CimNotificationFragmentDoc = gql`
  fragment cimNotification on NotificationType {
    category
    endDate
    heading
    id
    impact
    planDate
    startDate
    status
    summary
    tags
    type
    updates {
      language
      description
      timestamp
    }
    urgency
  }
`;
export const CimAffectedSubscriptionsFragmentDoc = gql`
  fragment cimAffectedSubscriptions on NotificationType {
    affectedSubscriptions @include(if: $includeAffectedSubscriptions) {
      subscriptionId
      impactType
      subscription {
        subscriptionId
        customerId
        description
        product {
          type
          name
        }
        customerDescription
      }
    }
  }
`;
export const PaginationInfoFragmentDoc = gql`
  fragment PaginationInfo on PageInfo {
    endCursor
    hasNextPage
    hasPreviousPage
    startCursor
    totalItems
  }
`;
export const SubscriptionListBaseFragmentFragmentDoc = gql`
  fragment SubscriptionListBaseFragment on SubscriptionDetails {
    subscriptionId
    healthSubscriptionId
    description
    tags
    status
    customerDescription
    customer {
      customerId
      fullname
    }
    product {
      type
      tag
    }
  }
`;
export const L2VpnListBaseFragmentFragmentDoc = gql`
  fragment L2VpnListBaseFragment on L2VpnSubscriptionType {
    subscriptionId
    healthSubscriptionId
    description
    tags
    status
    customerDescription
    customer {
      customerId
      fullname
    }
    product {
      type
      tag
    }
  }
`;
export const L3VpnListBaseFragmentFragmentDoc = gql`
  fragment L3VpnListBaseFragment on L3VpnSubscriptionType {
    subscriptionId
    healthSubscriptionId
    description
    tags
    status
    customerDescription
    customer {
      customerId
      fullname
    }
    product {
      type
      tag
    }
  }
`;
export const PortListBaseFragmentFragmentDoc = gql`
  fragment PortListBaseFragment on ServicePortSubscriptionType {
    subscriptionId
    healthSubscriptionId
    description
    tags
    status
    customerDescription
    customer {
      customerId
      fullname
    }
    product {
      type
      tag
    }
  }
`;
export const ServiceTypeFragmentFragmentDoc = gql`
  fragment ServiceTypeFragment on ServiceType {
    subscriptionId
    portSubscriptionInstanceId
    product {
      type
      tag
    }
    speed
    percentage
    description
  }
`;
export const PortServiceTypeFragmentFragmentDoc = gql`
  fragment PortServiceTypeFragment on PortServiceType {
    subscriptionId
    productType
    speed
    percentage
    description
  }
`;
export const MinifiedLinkedServicesFragmentFragmentDoc = gql`
  fragment MinifiedLinkedServicesFragment on ServiceType {
    subscriptionId
    portSubscriptionInstanceId
    sapSubscriptionInstanceId
    description
    customerDescription
    status
    speed
    percentage
    vlanrange
    product {
      type
      tag
      id
      name
    }
  }
`;
export const IpSapPortDataFragmentDoc = gql`
  fragment IpSapPortData on IPServiceAttachPointType {
    port {
      amountReserved
      description
      domain
      locationDescription
      portMode
      portSpeed
      speed
      status
      subscriptionId
      tags
      customerDescription
      product {
        id
        name
        tag
        type
      }
      customer {
        fullname
        customerId
      }
      services {
        ...MinifiedLinkedServicesFragment
      }
      locations {
        address {
          addition
          city
          countryCode
          extraAddressLine
          number
          street
          zipcode
        }
      }
    }
  }
  ${MinifiedLinkedServicesFragmentFragmentDoc}
`;
export const IpSapDataFragmentDoc = gql`
  fragment IpSapData on IPServiceAttachPointType {
    ...IpSapPortData
    subscriptionInstanceId
    bfd
    bfdMinimumInterval
    bfdMultiplier
    bgpExportPolicy
    bgpHashAlgorithm
    bgpPassword
    bgpSessionPriority
    gracefulRestart
    ipv4Mtu
    ipv6Mtu
    vlanrange
    ipPrefixes
    ipv4PointToPointPrefix {
      clientFQDN
      clientIpAddress
      network
      surfFQDN
      surfIpAddress
    }
    ipv6PointToPointPrefix {
      clientFQDN
      clientIpAddress
      network
      surfFQDN
      surfIpAddress
    }
  }
  ${IpSapPortDataFragmentDoc}
`;
export const BaseSubscriptionFragmentFragmentDoc = gql`
  fragment BaseSubscriptionFragment on SubscriptionDetails {
    customerId
    description
    endDate
    insync
    name
    organisation
    startDate
    status
    subscriptionId
    tags
    customerDescription
    minimalImpactNotification
    dirty
    product {
      id
      name
      tag
      type
    }
    references {
      externalId
      name
    }
  }
`;
export const LinkedServicesFragmentFragmentDoc = gql`
  fragment LinkedServicesFragment on ServiceType {
    insync
    subscriptionId
    portSubscriptionInstanceId
    sapSubscriptionInstanceId
    customerId
    status
    description
    customerDescription
    organisation
    status
    speed
    percentage
    vlanrange
    portSpeed
    amountReserved
    product {
      id
      name
      type
      tag
    }
    services {
      description
      percentage
      speed
      product {
        id
        name
        type
        tag
      }
    }
  }
`;
export const LightPathSubscriptionDetailsFragmentFragmentDoc = gql`
  fragment LightPathSubscriptionDetailsFragment on LightPathSubscriptionDetailsType {
    ...BaseSubscriptionFragment
    domain
    protection
    serviceId
    serviceSpeed
    speedPolicer
    product {
      id
      name
      type
      tag
    }
    saps {
      name
      organisation
      subscriptionInstanceId
      tag
      vlanrange
    }
    circuits {
      name
      remotePortShutdown
      serviceId
      serviceSpeed
      subscriptionInstanceId
      tag
      endpoints {
        name
        organisation
        subscriptionInstanceId
        tag
        vlanrange
        port {
          amountReserved
          customerDescription
          description
          domain
          portMode
          portSpeed
          speed
          status
          subscriptionId
          tags
          usedVlans
          customer {
            customerId
          }
          product {
            id
            name
            type
            tag
          }
          services {
            ...LinkedServicesFragment
          }
          address {
            addition
            city
            countryCode
            extraAddressLine
            number
            street
            zipcode
          }
        }
      }
    }
    topology {
      customerDescription
      otherSubscriptionId
      subscriptionInstanceId
      topologyObjectType
      vlanrange
      product {
        id
        name
        type
        tag
      }
    }
  }
  ${BaseSubscriptionFragmentFragmentDoc}
  ${LinkedServicesFragmentFragmentDoc}
`;
export const LinkMemberFragmentFragmentDoc = gql`
  fragment LinkMemberFragment on LinkMemberDetailsType {
    subscriptionId
    customerId
    description
    organisation
    customerDescription
    vlanrange
    patchPosition
    ieeeInterfaceType
    portSpeed
    amountReserved
    tags
    product {
      id
      name
      type
      tag
    }
    services {
      ...LinkedServicesFragment
    }
  }
  ${LinkedServicesFragmentFragmentDoc}
`;
export const GetAirtScansDocument = gql`
  query GetAirtScans($filter: SearchFilter = {}, $first: Int = 20, $after: Int = 0, $sort: AirtSort) {
    airtScans(searchFilter: $filter, first: $first, after: $after, sort: $sort) {
      edges {
        node {
          id
          importedAt
          modelVersion
          classification
          destination
          extra
          feed
          malware
          source
          time
          protocol
          numberOfHits
          lastSeen
          firstSeen
          severity
        }
      }
      pageInfo {
        ...PaginationInfo
      }
    }
  }
  ${PaginationInfoFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class GetAirtScansGQL extends Apollo.Query<GetAirtScansQuery, GetAirtScansQueryVariables> {
  document = GetAirtScansDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAirtScansClassificationProtocolDocument = gql`
  query GetAirtScansClassificationProtocol($filter: SearchFilter = {}) {
    airtScans(searchFilter: $filter, first: 999999) {
      edges {
        node {
          classification
          protocol
          severity
        }
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetAirtScansClassificationProtocolGQL extends Apollo.Query<
  GetAirtScansClassificationProtocolQuery,
  GetAirtScansClassificationProtocolQueryVariables
> {
  document = GetAirtScansClassificationProtocolDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAirtScansCountDocument = gql`
  query GetAirtScansCount($filter: SearchFilter = {}, $first: Int = 20, $after: Int = 0) {
    airtScans(searchFilter: $filter, first: $first, after: $after) {
      edges {
        node {
          id
          classification
          protocol
          severity
        }
      }
      pageInfo {
        ...PaginationInfo
      }
    }
  }
  ${PaginationInfoFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class GetAirtScansCountGQL extends Apollo.Query<GetAirtScansCountQuery, GetAirtScansCountQueryVariables> {
  document = GetAirtScansCountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CertMitigationPrefixesDocument = gql`
  query CertMitigationPrefixes($customer: UUID!) {
    ipPrefixDdos(searchFilter: { accessCustomerId: $customer }) {
      page {
        subscriptionId
        autoMitigation
        customerId
        description
        insync
        prefix
        status
        version
        afi
        dirty
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CertMitigationPrefixesGQL extends Apollo.Query<
  CertMitigationPrefixesQuery,
  CertMitigationPrefixesQueryVariables
> {
  document = CertMitigationPrefixesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CimNotificationsDocument = gql`
  query CimNotifications($filter: NotificationFilter!, $includeAffectedSubscriptions: Boolean = true) {
    notifications(searchFilter: $filter) {
      ...cimNotification
      ...cimAffectedSubscriptions
    }
  }
  ${CimNotificationFragmentDoc}
  ${CimAffectedSubscriptionsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class CimNotificationsGQL extends Apollo.Query<CimNotificationsQuery, CimNotificationsQueryVariables> {
  document = CimNotificationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CimNotificationsSubscriptionDocument = gql`
  query CimNotificationsSubscription($filter: NotificationFilter!) {
    notifications(searchFilter: $filter) {
      ...cimNotification
    }
  }
  ${CimNotificationFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class CimNotificationsSubscriptionGQL extends Apollo.Query<
  CimNotificationsSubscriptionQuery,
  CimNotificationsSubscriptionQueryVariables
> {
  document = CimNotificationsSubscriptionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CimMajorDisruptionNotificationsDocument = gql`
  query CimMajorDisruptionNotifications($filter: MajorDisruptionNotificationFilter!) {
    majorDisruptionNotifications(searchFilter: $filter) {
      ...cimNotification
    }
  }
  ${CimNotificationFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class CimMajorDisruptionNotificationsGQL extends Apollo.Query<
  CimMajorDisruptionNotificationsQuery,
  CimMajorDisruptionNotificationsQueryVariables
> {
  document = CimMajorDisruptionNotificationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CustomerWithMinimalImpactNotificationQueryDocument = gql`
  query CustomerWithMinimalImpactNotificationQuery($customerId: UUID!, $products: [String!]) {
    customerSubscriptions(customerId: $customerId, products: $products) {
      subscriptionId
      minimalImpactNotification
      description
      customerDescription
      product {
        type
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CustomerWithMinimalImpactNotificationQueryGQL extends Apollo.Query<
  CustomerWithMinimalImpactNotificationQueryQuery,
  CustomerWithMinimalImpactNotificationQueryQueryVariables
> {
  document = CustomerWithMinimalImpactNotificationQueryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDnsFirewallDocument = gql`
  query GetDnsFirewall(
    $filter: DnsFirewallSearchFilter = {}
    $first: Int = 20
    $after: Int = 0
    $sort: DnsFirewallSort
  ) {
    dnsFirewallLogs(searchFilter: $filter, first: $first, after: $after, sort: $sort) {
      edges {
        node {
          customerId
          ipAddress
          rpzFeed
          hit
          recordedAt
          resolver
          action
        }
        cursor
      }
      pageInfo {
        ...PaginationInfo
      }
    }
  }
  ${PaginationInfoFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class GetDnsFirewallGQL extends Apollo.Query<GetDnsFirewallQuery, GetDnsFirewallQueryVariables> {
  document = GetDnsFirewallDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PortAccessCustomerListQueryDocument = gql`
  query PortAccessCustomerListQuery($customer: UUID!) {
    subscriptions: portList(sort: { subscriptionId: ASC }, searchFilter: { accessCustomerId: $customer }) {
      page {
        ...PortListBaseFragment
        portSpeed
        portMode
        speed
        amountReserved
        services {
          ...ServiceTypeFragment
        }
        locations {
          address {
            city
            number
            street
            addition
          }
        }
      }
      pageInfo {
        totalItems
      }
    }
  }
  ${PortListBaseFragmentFragmentDoc}
  ${ServiceTypeFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class PortAccessCustomerListQueryGQL extends Apollo.Query<
  PortAccessCustomerListQueryQuery,
  PortAccessCustomerListQueryQueryVariables
> {
  document = PortAccessCustomerListQueryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PortCustomerListQueryDocument = gql`
  query PortCustomerListQuery($customer: UUID!) {
    subscriptions: portList(sort: { subscriptionId: ASC }, searchFilter: { customerId: $customer }) {
      page {
        ...PortListBaseFragment
        portSpeed
        portMode
        speed
        amountReserved
        usedVlans
        services {
          ...ServiceTypeFragment
        }
        address {
          city
          street
        }
      }
      pageInfo {
        totalItems
      }
    }
  }
  ${PortListBaseFragmentFragmentDoc}
  ${ServiceTypeFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class PortCustomerListQueryGQL extends Apollo.Query<
  PortCustomerListQueryQuery,
  PortCustomerListQueryQueryVariables
> {
  document = PortCustomerListQueryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const L3vpnListQueryDocument = gql`
  query L3vpnListQuery($customer: UUID!) {
    subscriptions: l3vpnList(sort: { subscriptionId: ASC }, searchFilter: { accessCustomerId: $customer }) {
      page {
        __typename
        ...L3VpnListBaseFragment
        locations {
          address {
            city
            number
            street
            addition
          }
        }
        firewallEnabled
      }
      pageInfo {
        totalItems
      }
    }
  }
  ${L3VpnListBaseFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class L3vpnListQueryGQL extends Apollo.Query<L3vpnListQueryQuery, L3vpnListQueryQueryVariables> {
  document = L3vpnListQueryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const L2vpnListQueryDocument = gql`
  query L2vpnListQuery($customer: UUID!) {
    subscriptions: l2vpnList(sort: { subscriptionId: ASC }, searchFilter: { accessCustomerId: $customer }) {
      page {
        __typename
        ...L2VpnListBaseFragment
        locations {
          address {
            city
            number
            street
            addition
          }
        }
        firewallEnabled
      }
      pageInfo {
        totalItems
      }
    }
  }
  ${L2VpnListBaseFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class L2vpnListQueryGQL extends Apollo.Query<L2vpnListQueryQuery, L2vpnListQueryQueryVariables> {
  document = L2vpnListQueryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LightPathListQueryDocument = gql`
  query LightPathListQuery($customer: UUID!) {
    subscriptions: evpnPtpList(sort: { subscriptionId: ASC }, searchFilter: { accessCustomerId: $customer }) {
      page {
        __typename
        ...SubscriptionListBaseFragment
        locations {
          address {
            city
            number
            street
            addition
          }
        }
        services {
          ...PortServiceTypeFragment
        }
      }
      pageInfo {
        totalItems
      }
    }
  }
  ${SubscriptionListBaseFragmentFragmentDoc}
  ${PortServiceTypeFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class LightPathListQueryGQL extends Apollo.Query<LightPathListQueryQuery, LightPathListQueryQueryVariables> {
  document = LightPathListQueryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const IpPrefixesListQueryDocument = gql`
  query IpPrefixesListQuery($customer: UUID!) {
    ipPrefixList(sort: { subscriptionId: ASC }, searchFilter: { accessCustomerId: $customer, status: ACTIVE }) {
      page {
        subscriptionType: __typename
        subscriptionId
        customerId
        description
        startDate
        customerDescription
        insync
        ipPrefix {
          afi
          state
          prefix
        }
        ipSubscriptions {
          subscriptionId
          customerId
          description
          customerDescription
          product {
            type
            tag
          }
        }
        availableIpSubscriptions {
          subscriptionId
          customerId
          description
          customerDescription
          product {
            type
            tag
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class IpPrefixesListQueryGQL extends Apollo.Query<IpPrefixesListQueryQuery, IpPrefixesListQueryQueryVariables> {
  document = IpPrefixesListQueryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const WirelessSubscriptionListQueryDocument = gql`
  query WirelessSubscriptionListQuery($customer: UUID!) {
    subscriptions: wirelessList(sort: { subscriptionId: ASC }, searchFilter: { accessCustomerId: $customer }) {
      page {
        __typename
        ...SubscriptionListBaseFragment
        name
        supplier
        sensorPresent
        jiraLocationId
        location {
          city
        }
      }
      pageInfo {
        totalItems
      }
    }
  }
  ${SubscriptionListBaseFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class WirelessSubscriptionListQueryGQL extends Apollo.Query<
  WirelessSubscriptionListQueryQuery,
  WirelessSubscriptionListQueryQueryVariables
> {
  document = WirelessSubscriptionListQueryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const WiredSubscriptionListQueryDocument = gql`
  query WiredSubscriptionListQuery($customer: UUID!) {
    subscriptions: wiredList(sort: { subscriptionId: ASC }, searchFilter: { accessCustomerId: $customer }) {
      page {
        __typename
        ...SubscriptionListBaseFragment
        name
        monitoringEnabled
        customCustomerAbbreviation
      }
      pageInfo {
        totalItems
      }
    }
  }
  ${SubscriptionListBaseFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class WiredSubscriptionListQueryGQL extends Apollo.Query<
  WiredSubscriptionListQueryQuery,
  WiredSubscriptionListQueryQueryVariables
> {
  document = WiredSubscriptionListQueryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const IpListQueryDocument = gql`
  query IpListQuery($customer: UUID!) {
    subscriptions: ipList(sort: { subscriptionId: ASC }, searchFilter: { accessCustomerId: $customer }) {
      page {
        ...SubscriptionListBaseFragment
        locations {
          address {
            city
            number
            street
            addition
          }
        }
        protection
      }
      pageInfo {
        totalItems
      }
    }
  }
  ${SubscriptionListBaseFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class IpListQueryGQL extends Apollo.Query<IpListQueryQuery, IpListQueryQueryVariables> {
  document = IpListQueryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FirewallListQueryDocument = gql`
  query FirewallListQuery($customer: UUID!) {
    subscriptions: firewallList(sort: { subscriptionId: ASC }, searchFilter: { accessCustomerId: $customer }) {
      page {
        ...SubscriptionListBaseFragment
      }
      pageInfo {
        totalItems
      }
    }
  }
  ${SubscriptionListBaseFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class FirewallListQueryGQL extends Apollo.Query<FirewallListQueryQuery, FirewallListQueryQueryVariables> {
  document = FirewallListQueryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BaseSubscriptionsOfTypeQueryDocument = gql`
  query BaseSubscriptionsOfTypeQuery($customerId: UUID!, $products: [String!], $statuses: [String!]) {
    customerSubscriptions(customerId: $customerId, products: $products, statuses: $statuses) {
      subscriptionId
      description
      customerDescription
      product {
        type
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class BaseSubscriptionsOfTypeQueryGQL extends Apollo.Query<
  BaseSubscriptionsOfTypeQueryQuery,
  BaseSubscriptionsOfTypeQueryQueryVariables
> {
  document = BaseSubscriptionsOfTypeQueryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SurfCertDdosItemsDocument = gql`
  query SurfCertDdosItems($customer: UUID!) {
    surfCertList(searchFilter: { accessCustomerId: $customer }) {
      page {
        customerDescription
        description
        productType
        status
        subscriptionId
        surfcertFilterEnabled
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class SurfCertDdosItemsGQL extends Apollo.Query<SurfCertDdosItemsQuery, SurfCertDdosItemsQueryVariables> {
  document = SurfCertDdosItemsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const WirelessListQueryDocument = gql`
  query WirelessListQuery($customer: UUID!) {
    subscriptions: wirelessList(searchFilter: { accessCustomerId: $customer }) {
      page {
        subscriptionId
        description
        customerDescription
        location {
          city
        }
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class WirelessListQueryGQL extends Apollo.Query<WirelessListQueryQuery, WirelessListQueryQueryVariables> {
  document = WirelessListQueryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FirewallSubscriptionDetailsDocument = gql`
  query FirewallSubscriptionDetails($subscriptionId: UUID!, $accessCustomerId: UUID!) {
    firewallDetails(subscriptionId: $subscriptionId, accessCustomerId: $accessCustomerId) {
      ...BaseSubscriptionFragment
      topology {
        customerDescription
        otherSubscriptionId
        subscriptionInstanceId
        topologyObjectType
        vlanrange
        product {
          id
          name
          type
          tag
        }
      }
      availabilityZone
      customerAsn
      domain
      firewallEnabled
      fwAsn
      protection
      serviceSpeed
      ipGateway {
        ipv4Mtu
        ipv6Mtu
        serviceSpeed
        subscriptionInstanceId
        surfcertFilter
        ipPrefixes
        sapSubscriptionInstanceIds
      }
      l3Endpoints {
        subscriptionId
        customerId
        description
        organisation
        otherSubscriptionId
        subscriptionInstanceId
        tags
        sapSubscriptionInstanceIds
        product {
          type
          tag
        }
      }
      l2Endpoints {
        subscriptionId
        customerId
        description
        ipv4PtpPrefixes
        ipv6PtpPrefixes
        organisation
        otherSubscriptionId
        subscriptionInstanceId
        tags
        sapSubscriptionInstanceIds
        product {
          type
          tag
        }
      }
      product {
        id
        name
        tag
        type
      }
    }
  }
  ${BaseSubscriptionFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class FirewallSubscriptionDetailsGQL extends Apollo.Query<
  FirewallSubscriptionDetailsQuery,
  FirewallSubscriptionDetailsQueryVariables
> {
  document = FirewallSubscriptionDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const IpBgpSubscriptionDetailsDocument = gql`
  query IpBgpSubscriptionDetails($subscriptionId: UUID!, $accessCustomerId: UUID!) {
    ipBgpDetails(subscriptionId: $subscriptionId, accessCustomerId: $accessCustomerId) {
      ...BaseSubscriptionFragment
      domain
      firewallEnabled
      ipRoutingType
      protection
      serviceSpeed
      product {
        id
        name
        tag
        type
      }
      ipss {
        surfcertFilter
        asn
      }
      saps {
        ...IpSapData
      }
      topology {
        topologyObjectType
        otherSubscriptionId
        subscriptionInstanceId
        vlanrange
        customerDescription
        product {
          id
          name
          type
          tag
        }
      }
    }
  }
  ${BaseSubscriptionFragmentFragmentDoc}
  ${IpSapDataFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class IpBgpSubscriptionDetailsGQL extends Apollo.Query<
  IpBgpSubscriptionDetailsQuery,
  IpBgpSubscriptionDetailsQueryVariables
> {
  document = IpBgpSubscriptionDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const IpStaticSubscriptionDetailsDocument = gql`
  query IpStaticSubscriptionDetails($subscriptionId: UUID!, $accessCustomerId: UUID!) {
    ipStaticDetails(subscriptionId: $subscriptionId, accessCustomerId: $accessCustomerId) {
      ...BaseSubscriptionFragment
      serviceSpeed
      firewallEnabled
      protection
      domain
      ipRoutingType
      product {
        id
        name
        tag
        type
      }
      ipss {
        surfcertFilter
        asn
      }
      saps {
        ...IpSapData
      }
      topology {
        customerDescription
        otherSubscriptionId
        subscriptionInstanceId
        topologyObjectType
        vlanrange
        product {
          id
          name
          type
          tag
        }
      }
    }
  }
  ${BaseSubscriptionFragmentFragmentDoc}
  ${IpSapDataFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class IpStaticSubscriptionDetailsGQL extends Apollo.Query<
  IpStaticSubscriptionDetailsQuery,
  IpStaticSubscriptionDetailsQueryVariables
> {
  document = IpStaticSubscriptionDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const IrbSubscriptionDetailsDocument = gql`
  query IrbSubscriptionDetails($subscriptionId: UUID!, $accessCustomerId: UUID!) {
    irbDetails(subscriptionId: $subscriptionId, accessCustomerId: $accessCustomerId) {
      ...BaseSubscriptionFragment
      label
      locationDescription
      surfLocationCode
      portSpeed
      portId
      portMode
      domain
      amountReserved
      subscriptionInstanceId
      portSubscription
      address {
        city
        street
        number
      }
      services {
        ...LinkedServicesFragment
      }
    }
  }
  ${BaseSubscriptionFragmentFragmentDoc}
  ${LinkedServicesFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class IrbSubscriptionDetailsGQL extends Apollo.Query<
  IrbSubscriptionDetailsQuery,
  IrbSubscriptionDetailsQueryVariables
> {
  document = IrbSubscriptionDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const L2vpnSubscriptionDetailsDocument = gql`
  query L2vpnSubscriptionDetails($subscriptionId: UUID!, $accessCustomerId: UUID!) {
    l2vpnDetails(subscriptionId: $subscriptionId, accessCustomerId: $accessCustomerId) {
      ...BaseSubscriptionFragment
      firewallEnabled
      domain
      serviceSpeed
      protection
      speedPolicer
      product {
        id
        name
        tag
        type
      }
      product {
        name
        tag
      }
      circuits {
        endpoints {
          name
          organisation
          subscriptionInstanceId
          tag
          vlanrange
          port {
            portMode
            subscriptionId
            tags
            speed
            customerDescription
            services {
              vlanrange
              insync
            }
          }
          address {
            city
            street
            number
          }
        }
      }
      topology {
        customerDescription
        otherSubscriptionId
        subscriptionInstanceId
        topologyObjectType
        vlanrange
        product {
          id
          name
          type
          tag
        }
      }
      saps {
        subscriptionInstanceId
        name
        port {
          subscriptionId
          description
          domain
          portMode
          portSpeed
          amountReserved
          speed
          status
          tags
          customerDescription
          customer {
            fullname
            customerId
          }
          product {
            id
            name
            tag
            type
          }
          services {
            ...MinifiedLinkedServicesFragment
          }
          locations {
            address {
              addition
              city
              countryCode
              extraAddressLine
              number
              street
              zipcode
            }
          }
        }
      }
      esis {
        segmentId
        firewallInterconnect {
          firewallSubscriptionId
          subscriptionInstanceId
        }
        endpoints {
          subscriptionInstanceId
          organisation
          name
          tag
          vlanrange
          port {
            subscriptionId
            description
            amountReserved
            portSpeed
            tags
            customerDescription
            usedVlans
            customer {
              fullname
              customerId
            }
            locations {
              address {
                addition
                city
                number
                street
              }
            }
            address {
              addition
              city
              countryCode
              extraAddressLine
              number
              street
              zipcode
            }
            services {
              ...MinifiedLinkedServicesFragment
            }
            product {
              id
              type
              tag
            }
          }
        }
      }
      firewallInterconnects {
        availabilityZone
        description
        firewallSubscriptionId
        subscriptionInstanceId
        organisation
        customerId
        endpoints {
          subscriptionInstanceId
        }
      }
    }
  }
  ${BaseSubscriptionFragmentFragmentDoc}
  ${MinifiedLinkedServicesFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class L2vpnSubscriptionDetailsGQL extends Apollo.Query<
  L2vpnSubscriptionDetailsQuery,
  L2vpnSubscriptionDetailsQueryVariables
> {
  document = L2vpnSubscriptionDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const L3vpnSubscriptionDetailsDocument = gql`
  query L3vpnSubscriptionDetails($subscriptionId: UUID!, $accessCustomerId: UUID!) {
    l3vpnDetails(subscriptionId: $subscriptionId, accessCustomerId: $accessCustomerId) {
      ...BaseSubscriptionFragment
      firewallEnabled
      domain
      insync
      serviceSpeed
      protection
      speedPolicer
      references {
        externalId
        name
      }
      product {
        id
        name
        tag
        type
      }
      circuits {
        endpoints {
          name
          organisation
          subscriptionInstanceId
          tag
          vlanrange
          port {
            customerDescription
            portMode
            subscriptionId
            tags
            speed
            services {
              vlanrange
              insync
            }
          }
          address {
            city
            street
            number
          }
        }
      }
      topology {
        customerDescription
        otherSubscriptionId
        subscriptionInstanceId
        topologyObjectType
        vlanrange
        product {
          id
          name
          type
          tag
        }
      }
      l3vpnss {
        l3vpnAsn
      }
      l3vpnsapss {
        subscriptionInstanceId
        name
        bfd
        bfdMinimumInterval
        bfdMultiplier
        bgpPassword
        ipv4Mtu
        ipv6Mtu
        bgpMetric
        ipv4Address
        ipv4MaxPrefix
        ipv6Address
        ipv4RemoteAddress
        ipv6MaxPrefix
        ipv6RemoteAddress
        sap {
          subscriptionInstanceId
          vlanrange
          port {
            description
            domain
            portMode
            portSpeed
            amountReserved
            speed
            status
            subscriptionId
            tags
            customerDescription
            product {
              id
              name
              tag
              type
            }
            customer {
              fullname
              customerId
            }
            services {
              ...MinifiedLinkedServicesFragment
            }
            address {
              addition
              city
              countryCode
              extraAddressLine
              number
              street
              zipcode
            }
            locations {
              address {
                addition
                city
                countryCode
                extraAddressLine
                number
                street
                zipcode
              }
            }
          }
        }
      }
      firewallInterconnects {
        availabilityZone
        firewallAsn
        ipv4Mtu
        ipv6Mtu
        ipv4Prefix
        ipv6Prefix
        ipv4MaxPrefix
        ipv6MaxPrefix
        ipv4AddressFirewall
        ipv6AddressFirewall
        firewallSubscriptionId
        subscriptionInstanceId
        organisation
        customerId
        customerDescription
        description
        saps {
          subscriptionInstanceId
          name
          tag
          organisation
          vlanrange
          address {
            street
            number
            city
          }
        }
      }
    }
  }
  ${BaseSubscriptionFragmentFragmentDoc}
  ${MinifiedLinkedServicesFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class L3vpnSubscriptionDetailsGQL extends Apollo.Query<
  L3vpnSubscriptionDetailsQuery,
  L3vpnSubscriptionDetailsQueryVariables
> {
  document = L3vpnSubscriptionDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LightpathSubscriptionDetailsDocument = gql`
  query LightpathSubscriptionDetails($subscriptionId: UUID!, $accessCustomerId: UUID!) {
    lpDetails(subscriptionId: $subscriptionId, accessCustomerId: $accessCustomerId) {
      ...LightPathSubscriptionDetailsFragment
    }
  }
  ${LightPathSubscriptionDetailsFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class LightpathSubscriptionDetailsGQL extends Apollo.Query<
  LightpathSubscriptionDetailsQuery,
  LightpathSubscriptionDetailsQueryVariables
> {
  document = LightpathSubscriptionDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LightpathRedundantSubscriptionDetailsDocument = gql`
  query LightpathRedundantSubscriptionDetails($subscriptionId: UUID!, $accessCustomerId: UUID!) {
    lrDetails(subscriptionId: $subscriptionId, accessCustomerId: $accessCustomerId) {
      ...LightPathSubscriptionDetailsFragment
    }
  }
  ${LightPathSubscriptionDetailsFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class LightpathRedundantSubscriptionDetailsGQL extends Apollo.Query<
  LightpathRedundantSubscriptionDetailsQuery,
  LightpathRedundantSubscriptionDetailsQueryVariables
> {
  document = LightpathRedundantSubscriptionDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AggspSubscriptionDetailsDocument = gql`
  query AggspSubscriptionDetails($subscriptionId: UUID!, $accessCustomerId: UUID!) {
    aggspDetails(subscriptionId: $subscriptionId, accessCustomerId: $accessCustomerId) {
      ...BaseSubscriptionFragment
      label
      locationDescription
      surfLocationCode
      portSpeed
      portId
      portMode
      domain
      amountReserved
      subscriptionInstanceId
      portSubscription
      linkMemberSubscriptions {
        ...LinkMemberFragment
      }
      address {
        city
        street
        number
      }
      services {
        ...LinkedServicesFragment
      }
      product {
        id
        name
        type
        tag
      }
    }
  }
  ${BaseSubscriptionFragmentFragmentDoc}
  ${LinkMemberFragmentFragmentDoc}
  ${LinkedServicesFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class AggspSubscriptionDetailsGQL extends Apollo.Query<
  AggspSubscriptionDetailsQuery,
  AggspSubscriptionDetailsQueryVariables
> {
  document = AggspSubscriptionDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MscSubscriptionDetailsDocument = gql`
  query MscSubscriptionDetails($subscriptionId: UUID!, $accessCustomerId: UUID!) {
    mscDetails(subscriptionId: $subscriptionId, accessCustomerId: $accessCustomerId) {
      ...BaseSubscriptionFragment
      label
      locationDescription
      surfLocationCode
      portSpeed
      portId
      portMode
      domain
      amountReserved
      subscriptionInstanceId
      serviceTag
      address {
        city
        street
        number
      }
      portSubscription {
        subscriptionId
        customerId
        description
      }
      services {
        ...LinkedServicesFragment
      }
      product {
        id
        name
        type
        tag
      }
    }
  }
  ${BaseSubscriptionFragmentFragmentDoc}
  ${LinkedServicesFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class MscSubscriptionDetailsGQL extends Apollo.Query<
  MscSubscriptionDetailsQuery,
  MscSubscriptionDetailsQueryVariables
> {
  document = MscSubscriptionDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PortSubscriptionDetailsDocument = gql`
  query PortSubscriptionDetails($subscriptionId: UUID!, $accessCustomerId: UUID!) {
    servicePortDetails(subscriptionId: $subscriptionId, accessCustomerId: $accessCustomerId) {
      __typename
      ...BaseSubscriptionFragment
      label
      locationDescription
      surfLocationCode
      portSpeed
      portMode
      autoNegotiation
      patchPosition
      fiberType
      connectorType
      ieeeInterfaceType
      domain
      amountReserved
      address {
        city
        street
        number
      }
      services {
        ...LinkedServicesFragment
      }
      aggregateParent {
        subscriptionId
        customerDescription
      }
      product {
        id
        name
        type
        tag
      }
    }
  }
  ${BaseSubscriptionFragmentFragmentDoc}
  ${LinkedServicesFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class PortSubscriptionDetailsGQL extends Apollo.Query<
  PortSubscriptionDetailsQuery,
  PortSubscriptionDetailsQueryVariables
> {
  document = PortSubscriptionDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const WiredSubscriptionDetailsDocument = gql`
  query WiredSubscriptionDetails($subscriptionId: UUID!, $accessCustomerId: UUID!) {
    wiredDetails(subscriptionId: $subscriptionId, accessCustomerId: $accessCustomerId) {
      ...BaseSubscriptionFragment
      monitoringEnabled
      customCustomerAbbreviation
      product {
        id
        name
        type
        tag
      }
    }
  }
  ${BaseSubscriptionFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class WiredSubscriptionDetailsGQL extends Apollo.Query<
  WiredSubscriptionDetailsQuery,
  WiredSubscriptionDetailsQueryVariables
> {
  document = WiredSubscriptionDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const WirelessSubscriptionDetailsDocument = gql`
  query WirelessSubscriptionDetails($subscriptionId: UUID!, $accessCustomerId: UUID!) {
    wirelessDetails(subscriptionId: $subscriptionId, accessCustomerId: $accessCustomerId) {
      ...BaseSubscriptionFragment
      sensorPresent
      supplier
      location {
        city
        country
        address
        accessPoints {
          brand
          model
          supplier
          ciStatus
        }
      }
      tickets {
        ticketId
        summary
        status {
          id
          name
        }
        created
        locations
      }
      product {
        id
        name
        type
        tag
      }
    }
  }
  ${BaseSubscriptionFragmentFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class WirelessSubscriptionDetailsGQL extends Apollo.Query<
  WirelessSubscriptionDetailsQuery,
  WirelessSubscriptionDetailsQueryVariables
> {
  document = WirelessSubscriptionDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const WirelessOrganisationTicketsDocument = gql`
  query WirelessOrganisationTickets($accessCustomerId: UUID!) {
    wirelessOrganisationTickets(accessCustomerId: $accessCustomerId) {
      ticketId
      summary
      status {
        id
        name
      }
      created
      locations
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class WirelessOrganisationTicketsGQL extends Apollo.Query<
  WirelessOrganisationTicketsQuery,
  WirelessOrganisationTicketsQueryVariables
> {
  document = WirelessOrganisationTicketsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
